<template>
  <div class="qrcode" v-if="loadingFlags == true">
    <div class="shareTabs">
      <van-tabs v-model="shareIndex" @change="shareTags()">
        <van-tab title="我要投保"></van-tab>
        <van-tab title="保单查询"></van-tab>
      </van-tabs>
    </div>
    <div class="poster" id="poster">
      <img :src="detail.poster + '@390h_750w_1e_1c'" :style="{ height: posterHeight + 'px' }" alt="" />
    </div>

    <div class="bar10px"></div>
    <div class="step1">
      <!-- 保险信息 -->
      <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">保险信息</div>
        </div>
        <div class="inp-box insurepeopel_box">
          <div class="item">
            <van-field
              label="保障计划"
              value="请选择保障计划"
              placeholder="请选择保障计划"
              v-model.trim="step1Data.planName"
              @click="openPlanFlag"
              readonly
              right-icon="arrow-down"
            />
          </div>
          <div class="item" v-if="planageFlag == 0">
            <van-field
              label="承保年龄"
              value="请选择承保年龄"
              placeholder="请选择承保年龄"
              v-model.trim="step1Data.planAge"
              readonly
            />
          </div>
          <div class="item" v-else>
            <van-field
              label="承保年龄"
              value="请选择承保年龄"
              placeholder="请选择承保年龄"
              v-model.trim="step1Data.planAge"
              @click="chosePlanAgeFlag = true"
              readonly
              right-icon="arrow-down"
            />
          </div>
          <div class="item" v-if="!detail.hasDestnation">
            <van-field
              readonly
              v-model.trim="step1Data.planAddr"
              label="目的地"
              placeholder="请输入目的地"
            />
          </div>
          <div
            class="item"
            @click="openSelectAddr()"
            v-if="detail.hasDestnation"
          >
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>目的地</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body" style="text-align: left; display: grid" >
                  <span v-if="step1Data.planAddr" style="font-size: 0.1rem; text-align: left; color: #323233" >{{ step1Data.planAddr }}</span>
                  <span v-else style="font-size: 0.1rem; text-align: left; color: red" >请选择目的地!</span>
                  <div style="position: absolute; right: 0" class="van-field__right-icon" >
                    <i class="van-icon van-icon-arrow-down"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <van-field
              label="保障期限"
              value="请选择保障期限"
              placeholder="请选择保障期限"
              v-model.trim="step1Data.planDay"
              @click="openChosePlanTime"
              readonly
              right-icon="arrow-down"
            />
          </div>
          <div class="item" :class="step1DataError.startTime ? 'error' : ''">
            <van-field
              v-if="loadList.effectiveType == 3"
              label="起保日期"
              value="请选择起保日期"
              placeholder="请选择起保日期"
              v-model.trim="step1Data.startTime"
              readonly />
            <van-field
              v-else
              label="起保日期"
              value="请选择起保日期"
              placeholder="请选择起保日期"
              v-model.trim="step1Data.startTime"
              @click="choseStartFlag = true"
              readonly
              right-icon="arrow-down" />
          </div>
          <div class="item" :class="step1DataError.endTime ? 'error' : ''">
            <van-field
              label="终保日期"
              value="请选择终保日期"
              placeholder="请选择终保日期"
              v-model.trim="step1Data.endTime"
              readonly
            />
            <!-- @click="choseEndFlag = true" right-icon="arrow-down" -->
          </div>
          <div class="item1">
            <div class="item1-text">
              注意：起保日期以保险公司出具的保险单正本（或承保确认函）为准，起保日期将不早于您的缴费日期。
            </div>
            <div style="color: red;font-size: 12px;text-align: left;line-height: 20px;" v-if="detail.canTodayBuy">
              本产品支持即时生效，若选择当天起保。则以支付后{{ todayBuyMin ? todayBuyMin : "1小时" }}作为起保时间。
            </div>
          </div>
        </div>
      </div>
      <div class="bar10px"></div>
      <!-- 被保险人 -->
      <div class="qrcode-info">
      <div class="title" style="display: flex; align-items: center; justify-content: space-between;">
        <div>被保险人信息</div>
        <div v-if="commonPersons && commonPersons.length > 1" style="color: #21c28f; font-size: 14px;" @click="importCommonInsured()">导入常用个人信息</div>
      </div>
      <div style="display: flex; align-items: center; margin-top: 16px;">
        <van-checkbox v-model="saveInsuredFlag" checked-color="#07c160" shape="square" icon-size="16px">
          <span>保存为常用个人信息</span>
        </van-checkbox>
      </div>
      <div class="name-info" v-if="InsuredList.length">
        <div class="name-list-text" style="display: flex; justify-content: space-between" v-for="(item, index) in InsuredList" :key="index">
          <div class="" style="display: flex; font-size: 13px; color: #333">
            <div style="padding-right: 4  px">{{ index + 1 }}</div>
            <div v-html="$options.filters.checkIdName(item.name)" style="padding-right: 4px" ></div>
            <div  v-html="$options.filters.checkIdCode(item.idCode, item.idType, that) " style="padding-right: 4px"></div>
            <div style="padding-right: 4px"> {{ item.sex == 1 ? "男" : "女" }} </div>
            <div v-html="$options.filters.checkBirthday(item.birthday, that)"></div>
          </div>
          <div class=""
            style="
              width: 45px;
              display: flex;
              justify-content: space-between;
              padding-top: 5px;
            "
          >
            <van-icon
              name="edit"
              color="#666"
              size="18px"
              @click="openInsured('edit', item, index)"
            />
            <van-icon
              name="delete"
              color="red"
              size="18px"
              @click="delInsurePeo(item, index)"
            />
          </div>
        </div>
      </div>
      <div class="" style="width: 100%; display: flex; justify-content: space-around" v-if="changeCheck == 0" >
        <div class="add-Btn" style="background: #fff"></div>
        <div class="add-Btn" @click="openInsured('add')">+ 添加被保险人</div>
      </div>
      <div class="Insurededit" v-if="changeCheck == 1">
        <div class="item-form InsuredModel_box">
          <div class="item">
            <van-field
              required
              v-model.trim="InsuredModel.name"
              @blur="yanzhengBlur('name', InsuredModel.name)"
              @focus="blurTimer()"
              label="姓名"
              placeholder="请输入姓名"
              value="请输入姓名"
            />
          </div>
          <div class="item" v-if="detail.hasPinyin">
            <van-field
              required
              v-model.trim="InsuredModel.pinyin"
              @blur="yanzhengBlur('pinyin', InsuredModel.pinyin)"
              @focus="blurTimer()"
              label="拼音"
              placeholder="请输入拼音"
              value="请输入拼音"
            />
          </div>
          <div class="item">
            <van-field
              required
              label="证件类型"
              value="请选择证件类型"
              placeholder="请选择证件类型"
              v-model.trim="InsuredModel.idType"
              @blur="yanzhengBlur('idType', InsuredModel.idType)"
              @focus="blurTimer()"
              @click="InsuredIdTypeFlag = true"
              readonly
              right-icon="arrow-down"
            />
          </div>
          <div class="item">
            <van-field
              required
              v-model.trim="InsuredModel.idCode"
              @blur="yanzhengBlur('idCode', InsuredModel.idCode)"
              @focus="blurTimer()"
              label="证件号码"
              value="请输入证件号码"
              placeholder="请输入证件号码"
            />
          </div>
          <div class="item">
            <van-field
              required
              label="出生日期"
              value="请选择出生日期"
              placeholder="请选择出生日期"
              v-model.trim="InsuredModel.birthDay"
              @click="InsuredBirthdayFlag = true"
              @focus="blurTimer()"
              readonly
              right-icon="calender-o"
            />
          </div>
          <div class="item">
            <van-field
              required
              label="性别"
              value="请选择性别"
              placeholder="请选择性别"
              v-model.trim="InsuredModel.sex"
              @click="InsuredSexFlag = true"
              @focus="blurTimer()"
              readonly
              right-icon="arrow-down"
            />
          </div>
          <div class="item" v-if="detail.insuranceCompanyId == 17">
          <van-field
            required
            label="我是投保人的:"
            value="请选择关系"
            v-model.trim="InsuredModel.relationship"
            @click="InsuredRelatFlag = true"
            readonly
            right-icon="arrow-down"
          />
        </div>
          <div class="item">
            <van-field
              v-model.trim="InsuredModel.phone"
              @focus="blurTimer()"
              type="number"
              label="手机号码"
              value="选填"
              placeholder="选填"
            />
          </div>
        </div>
        <div class="save-Btn" @click="addOneInsured()">
          保存被保险人（{{ InsuredList.length }} / 5）
        </div>
      </div>
      <div class="tipcheck" style="width: 100%">
        <van-checkbox
          style="width: 100%;margin-right:10px"
          v-model.trim="subchecked"
          checked-color="#07c160"
          shape="square"
          icon-size="16px"
        >
          <div class="text">
            本人已充分理解并同意
            <b style="color: #1285f7; cursor: pointer">
              <a
                style="
                  margin: 5px 0;
                  font-size: 14px;
                  padding-left: 0px;
                  margin-right: 5px;
                  color: #21c28f;
                "
                class="a-link"
                @click.stop="gotoPreview(1)"
                target="_blank"
                >《详细条款与除外责任》</a
              >
              <a
                style="
                  margin: 5px 0;
                  font-size: 14px;
                  padding-left: 0px;
                  margin-right: 5px;
                  color: #21c28f;
                "
                class="a-link"
                target="_blank"
                @click.stop="gotoPreview(2)"
                >《投保须知》</a
              >
              <a
              style="
                margin: 5px 0;
                font-size: 14px;
                padding-left: 0px;
                margin-right: 5px;
                color: #21c28f;
              "
              class="a-link"
              target="_blank"
              @click.stop="preview(detail.serviceFiles[0].response.url,detail.serviceFiles[0].name)"
              >《服务指引》</a
            >
              <a
                style="
                  margin: 5px 0;
                  font-size: 14px;
                  padding-left: 0px;
                  margin-right: 3px;
                  color: #21c28f;
                "
                class="a-link"
                target="_blank"
                @click.stop="
                  preview(
                    detail.customerFiles[0].response.url,
                    detail.customerFiles[0].name
                  )
                "
                >《客户告知书》</a
              >
            </b>
          </div>
        </van-checkbox>
        <van-checkbox
          style="width: 100%"
          @change="chageReady1"
          shape="square"
          v-model.trim="isReady1"
          checked-color="#21C28F"
          icon-size="16px"
        >
          <div class="text">
            本人已逐页阅读并同意
            <b style="color: #21c28f; cursor: pointer">
              《免责内容》 《被保险人同意声明》 《投保提示》
            </b>
          </div>
        </van-checkbox>
      </div>
      </div>
      <div class="bar10px"></div>
      <!-- 投保人信息 -->
      <div class="info" v-if="loadList.fixedOrNot == '0'">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">投保人信息</div>
          <div style="width: 230px">
            <van-checkbox
              shape="square"
              v-model.trim="checkAway"
              checked-color="#07c160"
              icon-size="13px"
              @change="checkAwayFn"
            >
              <div class="text" style="font-size: 14px">与第一被保人相同</div>
            </van-checkbox>
          </div>
        </div>
        <div class="inp-box insurepeopel_box" v-if="checkAway == false">
          <van-form validate-first>
            <div class="item" :class="insureError.name ? 'error' : ''">
              <van-field
                v-if="detail.insuranceCompanyId !== 17"
                @blur="blurInsure('name', policyHolder.name, true)"
                @focus="blurTimer()"
                required
                v-model.trim="policyHolder.name"
                label="投保人名称"
                placeholder="请输入投保人名称"
              />
              <van-field
                v-else
                @blur="blurInsure('name', policyHolder.name, true)"
                @focus="blurTimer()"
                required
                v-model.trim="policyHolder.name"
                label="投保人名称"
                placeholder="请输入投保人名称"
              />
            </div>
            <div
              v-if="detail.hasPinyin && policyHolder.idType != '社会信用代码'"
              class="item"
              :class="insureError.pinyin ? 'error' : ''"
            >
              <van-field
                @blur="blurInsure('pinyin', policyHolder.pinyin, true)"
                @focus="blurTimer()"
                required
                v-model.trim="policyHolder.pinyin"
                label="拼音"
                placeholder="请输入拼音"
              />
            </div>
            <div class="item">
              <van-field
                required
                label="证件类型"
                value="请选择证件类型"
                v-model.trim="policyHolder.idType"
                @click="idTypeFlag = true"
                readonly
                right-icon="arrow-down"
              />
            </div>
            <div class="item" :class="insureError.idCode ? 'error' : ''">
              <van-field
                @blur="blurInsure('idCode', policyHolder.idCode, true)"
                @focus="blurTimer()"
                required
                v-model.trim="policyHolder.idCode"
                name="checkIdcode"
                :rules="[{ checkIdcode, message: '请输入正确内容' }]"
                label="证件号码"
                placeholder="请输入证件号码"
              />
            </div>
            <div class="item" :class="insureError.birthday ? 'error' : ''">
              <van-field
                v-if="policyHolder.idType != '社会信用代码'"
                required
                label="出生日期"
                value="请选择出生日期"
                v-model.trim="policyHolder.birthDay"
                @click="birthdayFlag = true"
                @blur="blurInsure('birthday', policyHolder.birthDay, true)"
                @focus="blurTimer()"
                :min-date="InsuredModelMinDate"
                :max-date="maxDate"
                readonly
                placeholder="请选择出生日期"
                right-icon="calender-o"
              />
            </div>
            <div class="item">
              <van-field
                v-if="policyHolder.idType != '社会信用代码'"
                required
                label="性别"
                value="请选择性别"
                v-model.trim="policyHolder.sex"
                @click="sexFlag = true"
                @focus="blurTimer()"
                readonly
                right-icon="arrow-down"
              />
            </div>
            <div class="item" :class="insureError.phone ? 'error' : ''">
              <van-field
                @blur="blurInsure('phone', policyHolder.phone, true)"
                @focus="blurTimer()"
                required
                v-model.trim="policyHolder.phone"
                label="手机号码"
                placeholder="请输入手机号码"
              />
            </div>
            <div class="item" :class="insureError.email ? 'error' : ''">
              <van-field
                @blur="blurInsure('email', policyHolder.email, true)"
                @focus="blurTimer()"
                v-model.trim="policyHolder.email"
                label="邮箱"
                placeholder="用于接收保单链接"
              />
            </div>
          </van-form>
        </div>
      </div>
      <div class="bar10px"></div>
      <!-- 保障详情 -->
      <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">保障详情</div>
        </div>
        <div class="inp-box insurepeopel_box">
          <div class="item-sumary">
                <div class="text">
                  <ul class="summary-info">
                    <li v-for="(item, index) in summarys" :key="index" >
                      <div class="name">{{ item.name }}</div>
                      <div class="price">{{ item.price | countFilter }}元</div>
                    </li>
                  </ul>
                </div>
          </div>
        </div>
      </div>
      <div class="bar10px"></div>
      <!-- 理赔指引 -->
      <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">理赔指引</div>
        </div>
        <div class="inp-box insurepeopel_box">
          <div id="content4" class="info-item-box">
            <div class="partOne">
              <img
                src="./assets/images/zuo.png"
                style="width: 120px; height: 250px"
                mode=""
              />
              <img src="./assets/images/baoan.png" class="imgBaoan" mode="" />
              <div class="content-BA">
                <div class="ptitle">1、报案</div>
                <div class="ptext">您可以通过如下方式报案：</div>
                <div class="ptext">
                  ①微信报案：您可在“希望保”微信公众号平台进行报案（输入公众号，点击“用户服务”栏的“理赔报案”，填写报案信息即可成功报案）。
                </div>
                <div class="ptext">②电话报案：拨打电话4008933988进行报案。</div>
              </div>
            </div>
            <div class="partTwo">
              <div class="content-LP">
                <div class="ptitle">2、理赔材料准备</div>
                <div class="ptext">
                  报案成功后，我们会将理赔所需的材料及理赔相关注意事项发送至您的微信或邮箱。
                </div>
              </div>
              <img src="./assets/images/you.png" class="lineRight" mode="" />
              <img src="./assets/images/ziliao.png" class="imgBaoan" mode="" />
            </div>
            <div class="partThree">
              <img
                src="./assets/images/zuo.png"
                style="width: 130px; height: 145px"
                mode=""
              />
              <img src="./assets/images/shenhe.png" class="imgBaoan" mode="" />
              <div class="content-BA">
                <div class="ptitle">3、理赔资料提交</div>
                <div class="ptext">
                  待理赔材料递交到保险公司后，我们的理赔专员会按照保险公司所规定的时间跟进保险公司材料审核进度，确保客户第一时间得知理赔进度。
                </div>
              </div>
            </div>
            <div class="partFour">
              <div class="content-LP">
                <div class="ptitle">4、获得赔偿</div>
                <div class="ptext">
                  ①您提交的理赔材料经希望保理赔专员初审后转交给保险公司复核，复核无误后保险公司支付赔款。
                </div>
                <div class="ptext">
                  ②结案后希望保理赔专员会再次致电客户，告知赔付金额、打款时间和收款账户信息。
                </div>
              </div>
              <img src="./assets/images/peikuan.png" class="imgBaoan" mode="" />
            </div>
            <div class="info-title2">
              *涉及身故责任，第三者责任请务必及时联系保险公司
            </div>
            <div class="info-title3">
              若您在犹豫期过后解除保险合同，您会有一定的损失。保险公司自收到解除合同通知之日起三十日内，按照合同约定退还保险单的现金价值。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bar10px"></div>
     <div class="foot-btn">
      <div class="left" v-if="this.$route.query.accountId != 13081 && 
                this.$route.query.accountId != 26288 && 
                this.$route.query.accountId != 26524 && 
                this.$route.query.accountId != 23073 && 
                this.$route.query.accountId != 26536 && 
                this.$route.query.accountId != 25617 && showBalance == 1">
        <!-- <a href="tel://4008-933-988" v-if="stepActive == 0">
          <img src="./assets/images/tel.png" alt />
        </a>
        <span v-else style="font-weight: 800" @click="stepActive = 0"
          >上一步</span
        > -->
        <div class="price">
           <span style="color: #333">总保费：</span> ¥{{ price }}
          <span style="color: #333; padding-left: 5px">元</span>
        </div>
        <!-- <div class="price" v-else>
           <span style="color: #333"></span>
          <span style="color: #333; padding-left: 5px"></span>
        </div> -->
      </div>
      <div class="right">
        <van-button type="primary" style="background:#00d385;width:100%;height:100%" @click="prePayOrder()">{{ openBalance == 1 && openWeChatPay == 0 ? '领取保险' : '立即购买' }}</van-button>
      </div>
    </div>
    <van-popup v-model="datetimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm="confirmDate"
        :min-date="InsuredModelMinDate"
        :max-date="this.maxDate"
      />
    </van-popup>
    <div class="step1-dia">
      <!-- 选择计划 -->
      <van-popup
        v-model.trim="chosePlanFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择计划"
          show-toolbar
          :columns="plans"
          @confirm="onConfirmPlans"
          @cancel="chosePlanFlag = false"
        />
      </van-popup>
      <!-- 承保年龄 planAges-->
      <van-popup
        v-model.trim="chosePlanAgeFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择承保年龄"
          show-toolbar
          :columns="planAges"
          @confirm="onConfirmAge"
          @cancel="chosePlanAgeFlag = false"
        />
      </van-popup>
      <!-- 保障期限 -->
      <van-popup
        v-model.trim="chosePlanTimeFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择保障期限"
          show-toolbar
          :columns="planDays"
          @confirm="onConfirmDay"
          @cancel="chosePlanTimeFlag = false"
        />
      </van-popup>
      <!-- 起保日期 -->
      <van-popup v-model.trim="choseStartFlag" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择起保日期"
          @confirm="onConfirmStart"
          :min-date="minDate"
          :max-date="maxDate"
          v-model="currentDate"
          @cancel="onCancelStart"
        />
      </van-popup>
      <!-- 终保日期 -->
      <van-popup v-model.trim="choseEndFlag" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择终保日期"
          @confirm="onConfirmEnd"
          :min-date="minDate1"
          :max-date="maxDate1"
          v-model="currentDate"
          @cancel="choseEndFlag = false"
        />
      </van-popup>
      <!-- 投保人 -->
      <van-popup
        v-model.trim="idTypeFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择证件类型"
          show-toolbar
          :columns="idTypeOptions"
          @confirm="onConfirmId"
          @cancel="idTypeFlag = false"
        />
      </van-popup>
      <van-popup v-model.trim="birthdayFlag" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择出生日期"
          @confirm="onConfirmBirth"
          :min-date="birthdayMinDate"
          :max-date="birthdayMaxDate"
          v-model="currentDate"
          @cancel="birthdayFlag = false"
        />
      </van-popup>
      <van-popup
        v-model.trim="sexFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择性别"
          show-toolbar
          :columns="['男', '女']"
          @confirm="onConfirmSex"
          @cancel="sexFlag = false"
        />
      </van-popup>

      <!-- 被保人 -->
      <van-popup
        v-model.trim="InsuredIdTypeFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择证件类型"
          show-toolbar
          :columns="idTypeOption"
          @confirm="onConfirmIdInsured"
          @cancel="InsuredIdTypeFlag = false"
        />
      </van-popup>
      <van-popup
        v-model.trim="InsuredSexFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择性别"
          show-toolbar
          :columns="['男', '女']"
          @confirm="onConfirmSexInsured"
          @cancel="InsuredSexFlag = false"
        />
      </van-popup>
      <van-popup v-model.trim="InsuredBirthdayFlag" position="bottom">
        <van-datetime-picker
          v-model.trim="InsuredModel.currentDate"
          type="date"
          title="选择年月日"
          @confirm="onConfirmBirthInsured"
          :min-date="InsuredModelMinDate"
          :max-date="InsuredModelMaxDate"
          @cancel="InsuredBirthdayFlag = false"
        />
      </van-popup>
      <!-- 我和投保人关系 -->
      <van-popup
        v-model.trim="InsuredRelatFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择关系"
          show-toolbar
          :columns="relationList"
          @confirm="onConfirmRelatInsured"
          @cancel="InsuredRelatFlag = false"
        />
      </van-popup>
      <!-- 确认进入投保流程 -->
      <van-dialog
        v-model="noticePdfFlag"
        confirmButtonColor="#00d385"
        width="95%"
      >
        <div class="noticePdf" style="padding: 10px">
          <div class="title">确认进入投保流程</div>
          <div class="info">
            <p>尊敬的客户：</p>
            <p class="in">
              您即将进入投保流程，请仔细阅读保险条款。本保险产品由【
              <span>{{ detail.insuranceCompany }}</span>
              】承保，由希望天源保险经纪有限公司提供销售和协助理赔等保险服务。
            </p>
            <p class="in">
              投保前请仔细阅读
              <span
                @click="
                  preview(
                    detail.noticePdf[0].response.url,
                    detail.noticePdf[0].name
                  )
                "
                >客户告知书</span
              >
            </p>
            <p class="huang">
              点击“确认”即可开始投保，您在销售页面的操作将被依法记录和保存。
            </p>
          </div>
        </div>
        <!-- <div class="dialog-footer">
          <van-button type="primary" style="width:100%" @click="noticePdfFlag = false;noticePdfFlag1 = false;">确认开始投保</van-button>
        </div> -->
        <span slot="footer" class="dialog-footer">
          <van-button @click="noticePdfCancel()">暂不投保</van-button>
          <van-button
            type="primary"
            @click="
              noticePdfFlag = false;
              noticePdfFlag1 = false;
            "
            >确认开始投保</van-button
          >
        </span>
      </van-dialog>
      <!-- 阅读须知 -->
      <van-dialog
        v-model="regPdfFlag"
        confirmButtonColor="#00d385"
        confirmButtonText="已阅读"
        :width="pageWidth"
      >
        <div>
          <div
            style="
              max-height: 450px;
              overflow-y: scroll;
              -webkit-overflow-scrolling: touch;
            "
          >
            <div>
              <pdf
                :src="regPdfFUrl"
                :page="currentPage"
                @num-pages="pageCount = $event"
                @page-loaded="currentPage = $event"
                @loaded="loadPdfHandler"
              >
              </pdf>
            </div>
          </div>

          <p
            class="arrow"
            style="
              display: flex;
              justify-content: space-evenly;
              align-items: center;
              height: 50px;
            "
          >
            <span
              @click="changePdfPage('pre')"
              class="turn"
              :style="{ color: currentPage == 1 ? 'gray' : '' }"
              >Preview</span
            >
            {{ currentPage }} / {{ pageCount }}
            <span
              @click="changePdfPage('next')"
              class="turn"
              :style="{ color: currentPage == pageCount ? 'gray' : '' }"
              >Next</span
            >
          </p>
        </div>
        <!-- <div class="dialog-footer">
          <van-button type="primary" style="width:100%" @click="noticePdfFlag = false;noticePdfFlag1 = false;">确认开始投保</van-button>
           <van-button type="primary" style="width:100%" @click="noticePdfFlag = false;noticePdfFlag1 = false;regPdfFlag = false" >我已阅读并同意</van-button>
        </div> -->
      </van-dialog>
      <!-- 免责内容 -->
      <van-dialog
        @closed="closedIsReady1"
        :showConfirmButton="false"
        v-model="isReady1Flag"
        :width="pageWidth"
      >
        <div>
          <van-tabs v-model="isReady1Index">
            <van-tab title="《免责内容》" name="1">
              <div class="isReady_content">
                <div class="content" v-html="detail.exemption"></div>
              </div>
            </van-tab>
            <van-tab title="《被保险人同意声明》" name="2">
              <div class="isReady_content">
                <div class="content" style="line-height:20px" v-html="detail.agreement"></div>
              </div>
            </van-tab>
            <van-tab title="《投保提示》" name="3">
              <div class="isReady_content">
                <div class="content"  style="line-height:20px" v-html="detail.insureNotice"></div>
              </div>
            </van-tab>
          </van-tabs>
          <div
            style="
              display: flex;
              justify-content: center;
              height: 60px;
              align-items: center;
            "
          >
            <van-button
              type="primary"
              @click="changeIsReady1Index(isReady1Index)"
            >
              我已阅读 <span v-if="isReady1Index == 1">《免责内容》</span
              ><span v-if="isReady1Index == 2">《被保险人同意声明》</span
              ><span v-if="isReady1Index == 3">《投保提示》</span>
            </van-button>
          </div>
        </div>
      </van-dialog>
      <!-- 支付方式 -->

      <van-dialog
        class="copy-text"
        v-model.trim="isShowPay"
        title="支付方式"
        width="250"
        show-cancel-button
        @confirm="payOrder()">
        <div class="box copy_text" style="padding: 20px; box-sizing: border-box">
          <van-radio-group v-model="payType">
            <div v-if="openBalance == 1">
              <van-radio checked-color="#2ADA78" shape="square" :name="3" style="margin-bottom: 15px" v-if="openBalance == 1">
                <div style="font-size: 12px;color: #333;font-weight: 600;display: flex;align-items: center;">
                  <img style="width: 25px; margin-right: 10px" src="./assets/images/dai.png" alt=""/>余额支付
                </div>
              </van-radio>
              <van-radio checked-color="#2ADA78" shape="square" :name="1" v-if="this.$route.query.accountId != 13081 && openWeChatPay == 1 ">
                <div style="font-size: 12px;color: #333;font-weight: 600; display: flex;align-items: center;">
                  <img v-if="this.$page.isInAlipay" style="width: 25px; margin-right: 10px" src="./assets/images/alipay.png" alt=""/>
                  <img v-else style="width: 25px; margin-right: 10px" src="./assets/images/wechat.png" alt=""/>
                  {{ this.$page.isInAlipay ? '支付宝支付' : '微信支付' }}
                </div>
              </van-radio>
            </div>
            <div v-else>
              <van-radio checked-color="#2ADA78" shape="square" :name="1" v-if="this.$route.query.accountId != 13081">
                <div style="font-size: 12px;color: #333;font-weight: 600; display: flex;align-items: center;">
                  <img v-if="this.$page.isInAlipay" style="width: 25px; margin-right: 10px" src="./assets/images/alipay.png" alt=""/>
                  <img v-else style="width: 25px; margin-right: 10px" src="./assets/images/wechat.png" alt=""/>
                  {{ this.$page.isInAlipay ? '支付宝支付' : '微信支付' }}
                </div>
              </van-radio>
            </div>
          </van-radio-group>
        </div>
      </van-dialog>

      <div class="payStyle">
        <van-popup
          v-if="this.loadList.whetherPayCode == '1'"
          v-model="payMoneyFlag"
          round
          closeable
          close-icon="close"
          position="bottom"
          :style="{ height: '70%' }"
        >
          <div class="payTitle">请输入保险支付密码</div>
          <div class="payPrice" v-if="this.$route.query.accountId != 13081 && showBalance == 1">保费：{{ totalPricePay }}</div>
          <div class="payTypeStyle">
            <div>支付方式</div>
            <div>
              <van-icon
                name="balance-o"
                size="20"
                style="width:22px;vertical-align: middle;position: relative;top: -3px;"
              />余额支付
            </div>
          </div>
          <div>
            <van-password-input
              :value="paymentCodePwd"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
            />
            <!-- 数字键盘 -->
            <van-number-keyboard
              v-model="paymentCodePwd"
              :show="showKeyboard"
              @blur="showKeyboard = true"
            />
          </div>
        </van-popup>
      </div>

      <van-popup v-model="popPersonFlag" position="bottom" style="max-height: 70vh;">
        <div style="position: fixed; left:0; right: 0; padding: 24px 32px 12px; background: white; width: 100%; z-index: 2000; box-sizing: border-box;">
          <div style="text-align: center; font-size: 16px; color: #333; font-weight: 600;">常用个人信息</div>
          <img @click="popPersonFlag=false" style="position: absolute; top: 8px; right: 12px; width: 24px; height: 24px;" src="./assets/images/close_circle.png" alt="">
        </div>
        <div style="padding-top: 50px;">
          <div v-for="(person, indx) in commonPersons" :key="indx">
            <div style="display: flex; align-items: center; justify-content: space-between; padding: 12px 30px 12px 24px; border-bottom:1px solid #eee;">
              <div style="display: flex; align-items: center;">
                <img style="width: 40px; height: 40px;" src="./assets/images/insured_mark.png" alt="">
                <div style="margin-left: 15px;">
                  <div style="color: #333; font-size: 15px;">{{ person.name }}</div>
                  <div style="color: #999; margin-top: 10px; font-size: 13px;">{{ person.idType }}｜{{ person.idCode }}</div>
                </div>
              </div>
              <div>
                <van-checkbox v-model="person.selected" checked-color="#07c160" shape="square" icon-size="16px"></van-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div style="width: fit-content; border: 1px solid #21c28f; color: #21c28f; padding: 8px 40px; margin: 20px auto 30px;" @click.stop="confirmImport()">导入</div>
      </van-popup>
    </div>
    <selectAddr
      ref="selectAddr"
      :needSelect="detail.goDestnations"
      :value.sync="destinationArr"
    />
  </div>
</template>

<script>
import {
  Rate,
  Button,
  Tab,
  Tabs,
  Popup,
  Field,
  DatetimePicker,
  Icon,
  Picker,
  Toast,
  Checkbox,
  CheckboxGroup,
  Form,
  Dialog,
  RadioGroup,
  Radio,
  PasswordInput,
  NumberKeyboard,
  Loading
} from "vant";
import pdf from "vue-pdf";
import wechatService from "@/services/request/wechatService.js";
import util from "@/libs/util.js";
import $ from "jquery";
import loadPinYinInit from "./ChineseHelper.js";
import storejs from "store";
import moment from "moment";
import axios from "axios";
import selectAddr from "./selectAddr.vue";
import CryptoJS from "crypto-js";

export default {
  name: "Qrcode",
  components: {
    [Rate.name]: Rate,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Form.name]: Form,
    [Dialog.Component.name]: Dialog.Component,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [PasswordInput.name]: PasswordInput,
    [NumberKeyboard.name]: NumberKeyboard,
    [Loading.name]: Loading,
    pdf,
    selectAddr,
  },
  data() {
    return {
      that: this,
      moment: moment,
      allow:false,
      publicData: storejs.get("publicData"),
      id: "",
      posterHeight: 250,
      detail: {},
      setAges: [],
      destinationArr: [],
      chosePlanFlag: false,
      minDate111: new Date(2020, 0, 1),
      maxDate111: new Date(2025, 10, 1),
      currentDate111: new Date(),
      rateNum: 5,
      openId: "",
      unionId: "",
      selectPlans: 0,
      selectCycle: 0,
      selectTime: 0,
      selectAge: 0,
      price: 0,
      planageFlag: 0,
      selectModel: {
        selectPlans: 0,
        selectCycle: 0,
        selectTime: 0,
        selectAge: 0,
      },
      InsuredList: [],
      InsuredModel: {
        name: "",
        pinyin: "",
        idType: "身份证",
        idCode: "",
        sex: "男",
        birthDay: "",
        relationship:"",
        birthDayTime: "",
        phone: "",
        currentDate: "",
      },
      summarys: [],
      setTimes: [],
      sectionArr: [
        {
          id: 0,
          content: "",
          name: "产品详情",
        },
        {
          id: 1,
          content: "",
          name: "投保须知",
        },
        {
          id: 2,
          content: "",
          name: "常见问题",
        },
      ],
      step1Data: {
        name: "",
        planName: "",
        planIndex: 0,
        planAge: "",
        planAddr: "",
        planDay: "",
        startTime: "",
        endTime: "",
      },
      step1DataError: {
				destination: false,
				startTime: false,
				endTime: false,
			},
      insureError: {
        name: false,
        idCode: false,
        birthday: false,
        phone: false,
        email: false,
      },
      policyHolder: {
        //投保人信息
        name: "",
        pinyin: "",
        idType: "身份证",
        idCode: "",
        sex: "男",
        birthDay: "",
        birthDayTime: moment(1594137600000).format("YYYY-MM-DD"),
        phone: "",
        email: "",
        currentDate: "",
      },
      plans: [],
      todayBuyMin: 0,
      tabActive: "",
      InsuredRelatFlag:false,
      chosePlanAgeFlag: false,
      choseStartFlag: false,
      choseEndFlag: false,
      choseInfoFlag: false,
      chosePlanTimeFlag: false,
      datetimePicker: false,
      minDate: new Date(),
      minDate1: new Date(),
      currentDate: new Date(),
      currentDate1: new Date(),
      InsuredModelMaxDate: new Date(),
      InsuredModelMinDate:new Date(1920, 0, 1),
      birthdayMaxDate: new Date(),
      birthdayMinDate: new Date(1920, 0, 1),
      startTime: "请选择保险起保时间",
      showTip: false,
      insuranceCompanyLogo: "",
      shareIndex: 0,
      changeCheck: 1,
      idTypeFlag: false,
      sexFlag: false,
      birthdayFlag: false,
      InsuredBirthdayFlag: false,
      InsuredIdTypeFlag: false,
      InsuredSexFlag: false,
      idTypeOption: ["身份证", "护照", "其他"],
      idTypeOptions: ["社会信用代码", "身份证", "护照", "其他"],
      idTypeOptionw: ["护照", "其他"],
      relationList:['本人', '配偶','父母','子女'],
      regPdfFlag: false,
      regPdfFUrl: "",
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf", // 文件类型
      pageWidth: window.innerWidth - 10,
      noticePdfFlag: false,
      noticePdfFlag1: false,
      subchecked: false,
      riskchecked: false,
      checkAway: false,
      //逐步阅读条款
      isReady: false,
      isReady1: false,
      isReady1Flag: false,
      isShowPay: false,
      payMoneyFlag: false,
      showKeyboard: true,
      isReady1Index: "1",
      whetherPayCode: "",
      isReady1Arr: [0, 0, 0],
      openInsureType: "add",
      loadList: [],
      openBalance: 0, //是否支持余额支付 1是0否
      openWeChatPay:0, //是否支持微信支付/支付宝支付 1是0否
      payType: 1, //1微信/支付宝支付 2信用支付 3余额支付
      orderIds: "",
      paymentCodePwd: "",
      totalPricePay: 0,
      planDays: [],
      planAges: [],
      info: {},
      billId: "",
      checkPolicy:{},
      payBanFlag:false,
      loadingFlags:false,
      showBalance:'1',
      saveInsuredFlag: false, //是否保存为常用个人信息
      popPersonFlag: false, //是否弹出常用被保人选择
      commonPersons: [], //常用被保险人
      repeatBuy: 0, //是否支持重复购买
    };
  },
  mounted() {    
    //清空登录信息缓存
    util.cookies.remove('token');
    util.cookies.remove('uuid');
    storejs.set('publicData', {});

    this.initStyle();
    if (this.$page.isInWechat) {
      wechatService.auth(
        0,
        ({ openid, unionid }) => {
          if (!!openid && !!unionid) {
            this.unionId = unionid;
            this.openId = openid;
            this.getCommonInsured();
          }
        },
        false
      );
    }

    this.getChecklist()
  },
  computed: {
    // 投保时间限制
    maxDate() {
      // let curDate = new Date().getTime();
      // let one = 365 * 24 * 3600 * 1000;
      // let oneYear = curDate + one;
      // return new Date(oneYear);
      if(this.detail.id == 36){
        let curDate = new Date().getTime();
        let one = (365 * 2) * 24 * 3600 * 1000;
        let oneYear = curDate + one;
        return new Date(oneYear);
      }else{
        let curDate = new Date().getTime();
        let one = 365 * 24 * 3600 * 1000;
        let oneYear = curDate + one;
        return new Date(oneYear);
      }
    },
    maxDate1() {
      let curDate = new Date().getTime();
      let one = 365 * 24 * 3600 * 1000;
      let oneYear = curDate + one;
      return new Date(oneYear);
    },
  },
  watch: {
    // selectModel: {
    //   handler(val) {
    //     console.log(val);
    //     if (!!this.detail.plans.length) {
    //       let start =
    //         this.detail.plans[this.selectModel.selectPlans].cycle[
    //           this.selectModel.selectTime
    //         ].start;
    //       let end =
    //         this.detail.plans[this.selectModel.selectPlans].cycle[
    //           this.selectModel.selectTime
    //         ].end;
    //       let startAge =
    //         this.detail.plans[this.selectModel.selectPlans].cycle[
    //           this.selectModel.selectTime
    //         ].startAge;
    //       let endAge =
    //         this.detail.plans[this.selectModel.selectPlans].cycle[
    //           this.selectModel.selectTime
    //         ].endAge;
    //       let arr = [];

    //       this.detail.plans[this.selectModel.selectPlans].cycle.forEach(
    //         (el) => {
    //           arr.push({
    //             start: el.startAge,
    //             end: el.endAge,
    //           });
    //           if (el.start == start) {
    //             if (this.choseInfoFlag) {
    //               this.price = el.price;
    //             } else {
    //               this.price =
    //                 this.detail.plans[
    //                   this.selectModel.selectPlans
    //                 ].cycle[0].price;
    //             }
    //           }
    //         }
    //       );
    //       for (let i = arr.length; i > 0; i--) {
    //         for (let j = i - 1; j > -1; j--) {
    //           if (JSON.stringify(arr[i]) === JSON.stringify(arr[j])) {
    //             console.log(arr[j]);
    //             arr.splice(j, 1);
    //           }
    //         }
    //       }
    //       this.setAges = arr;
    //       let timeArr = [];
    //       this.detail.plans[this.selectModel.selectPlans].cycle.forEach(
    //         (el) => {
    //           // setTimes
    //           // console.log("el",el)
    //           // console.log(el.startAge , arr[this.selectModel.selectAge].start)
    //           // console.log(el.endAge , arr[this.selectModel.selectAge].end)
    //           if (
    //             el.startAge == arr[this.selectModel.selectAge].start &&
    //             el.endAge == arr[this.selectModel.selectAge].end
    //           ) {
    //             // console.log("el",el)
    //             timeArr.push(el);
    //           }
    //         }
    //       );
    //       this.setTimes = timeArr;
    //       this.price = this.setTimes[this.selectModel.selectTime].price;
    //     }
    //   },
    //   deep: true,
    // },
    policyHolder: {
      //投保人监听
      handler(val) {
        if (this.policyHolder.idType == "身份证") {
          if (this.policyHolder.idCode.length == 18) {
            let birthday = this.getBirthdayFromIdCard(this.policyHolder.idCode);
            this.policyHolder.birthDay = birthday;
            if (parseInt(this.policyHolder.idCode.substr(16, 1)) % 2 == 1) {
              this.policyHolder.sex = "男";
            } else {
              this.policyHolder.sex = "女";
            }
          }
        }
        if (this.policyHolder.idType != "社会信用代码") {
          this.insuredDisabled = false;
        } else {
          this.insuredDisabled = true;
        }
      },
      deep: true,
    },
    InsuredModel: {
      //被保人监听
      handler(val) {
        // console.log(val)
        if (this.InsuredModel.idType == "身份证") {
          if (this.InsuredModel.idCode.length == 18) {
            let birthday = this.getBirthdayFromIdCard(this.InsuredModel.idCode);
            this.InsuredModel.birthDay = birthday;
            this.InsuredModel.currentDate = birthday;
            this.InsuredModel.birthDayTime = birthday;
            if (parseInt(this.InsuredModel.idCode.substr(16, 1)) % 2 == 1) {
              this.InsuredModel.sex = "男";
            } else {
              this.InsuredModel.sex = "女";
            }
          }
        }
        if (this.detail.hasPinyin) {
          val.pinyin = loadPinYinInit.ConvertPinyin(val["name"]);
        }
        if(this.detail.insuranceCompanyId == 17){
          let birthday = this.moment(this.InsuredModel.birthDay).format("YYYY-MM-DD");
            let age = util.jsGetAge(birthday);
              if(age < 18){
                this.relationList = ['子女']
              }else{
                this.relationList = ['本人', '配偶','父母','子女']
              }
        }
      },
      deep: true,
    },
    destinationArr: function (val) {
      if (val && val.length) {
        this.step1Data.planAddr = val.join(",");
      } else {
        this.step1Data.planAddr = "";
      }
    },
    paymentCodePwd: {
      handler(val) {
        if (val.length === 6) {
          this.buildBill(this.orderIds);
        }
      },
      deep: true,
    },
  },
  methods: {
    async getCommonInsured(){
      let params = {
        openId: this.openId,
        qrCodeId: this.$route.query.id,
        queryKey: '',
        pageNumber: 1,
        pageSize: 1000,
      }
      let res = await this.$http.post("/api/oftenInsureds/getList", params);
      if(res.list) {
        this.commonPersons = res.list;
        if(this.commonPersons.length == 1){
          try {
            this.InsuredList = JSON.parse(JSON.stringify(this.commonPersons)) 
          } catch (error) {
            
          }
        }
      }
    },
    importCommonInsured(){
      this.commonPersons.forEach(item => {
        this.$set(item, 'selected', false);
      })
      this.popPersonFlag = true;
    },
    confirmImport(){
      let selectedRows = [];
      for(let person of this.commonPersons) {
        if(person.selected){
          selectedRows.push(person);
        }
      }
      if(selectedRows.length == 0){
        this.$toast('请勾选用户导入');
        return;
      }
      this.InsuredList = [...selectedRows, ...this.InsuredList];
      this.popPersonFlag = false;
    },
    async saveCommonInsures(){
      let res = await this.$http.post("/api/oftenInsureds/add", {
        qrCodeId: this.$route.query.id,
        openId: this.openId,
        personnelInfos: JSON.stringify(this.InsuredList),
      })
      if(res.code == 0){
        //保存常用成功
      }else{
        if(res && res.msg) {
          this.$toast.fail(res.msg);
        }
      }
    },
    openPlanFlag(){
      // if (!this.step1Data.startTime) {
      //     Dialog.confirm({
      //       title: "提示",
      //       message: '请选择起保日期！',
      //       confirmButtonText: "确定",
      //       showCancelButton:false,
      //     }).then(() => {
      //         this.step1DataError.startTime = true
      //         return
      //     }).catch(() => {});
      //     return
      // }
      this.chosePlanFlag = true
    },
    openChosePlanTime(){
      // if (!this.step1Data.startTime) {
      //     Dialog.confirm({
      //       title: "提示",
      //       message: '请选择起保日期！',
      //       confirmButtonText: "确定",
      //       showCancelButton:false,
      //     }).then(() => {
      //         this.step1DataError.startTime = true
      //         return
      //     }).catch(() => {});
      //     return
      // }
      this.chosePlanTimeFlag = true
    },
    initStyle() {
      let width = window.innerWidth;
      let height = width;
      this.posterHeight = height * 0.52;
      this.minDate = new Date();
      console.log(new Date());
    },
    blurTimer() {
      if (!this.step1Data.startTime) {
          Dialog.confirm({
            title: "提示",
            message: '请选择起保日期！',
            confirmButtonText: "确定",
            showCancelButton:false,
          }).then(() => {
              this.step1DataError.startTime = true
              return
          }).catch(() => {});
      }else{
        this.step1DataError.startTime = false
      }
			// if (!this.step1Data.startTime) {
      //   this.$toast("请选择起保日期！");
      //   this.step1DataError.startTime = true
      //   return
			// }
			// if (!this.step1Data.endTime) {
			// 	this.step1DataError.endTime = true
			// 	return
			// }
		},
    confirmDate(value) {
      console.log(value.getTime());
      this.startTime = moment(value.getTime()).format("YYYY-MM-DD");
      this.datetimePicker = false;
    },
    async getChecklist(){
        let res = await this.$http.post("/api/insuranceQrCode/QrCode/check", {
          qrCodeId:this.$route.query.id
        })
        if(res && res.code == 502 && res.msg == '二维码已失效或不存在！'){
          this.loadingFlags = false
          Dialog.confirm({
            title: "提示",
            message: '产品二维码已失效！',
            confirmButtonText: "确定",
            showCancelButton:false,
          }).then(() => {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                console.log('是微信浏览器');
                WeixinJSBridge.call('closeWindow');
            } else {
                console.log('不是微信浏览器');
                window.close()
            }
          })
        }else{
          this.loadingFlags = true
          this.init();
        } 
    },
    async changeStep() {
      if (!this.step1Data.startTime) {
        this.$toast("请选择起保日期！");
        this.step1DataError.startTime = true
        return
			}
      if (!this.step1Data.planAddr) {
        this.$toast("请选择国家！");
        return
			}
      if(!this.InsuredList.length){
          this.$toast("请先保存被保险人信息！");
          return;
      }
      //检测投保人
      let errinfos = [];
      let beibaoErrinfos = [];
      let policyHolder = {};
      this.checkPolicy = {}
      if (this.checkAway == true) {
        if(this.InsuredList.length){
          let insure = this.InsuredList[0];
          console.log("insure",insure)
          policyHolder = {
            name: insure.name,
            idType: insure.idType,
            idCode: insure.idCode,
            pinyin: insure.pinyin || "",
            sex:insure.sex,
            birthDay: insure.birthday,
            phone: insure.phone,
            email: insure.email || "",
          };
        }else{
          this.$toast("请先保存被保险人信息！");
          return;
        }
      } else {
        policyHolder = this.policyHolder;
      }

      this.checkPolicy = policyHolder

      // if (policyHolder.name.length < 2) {
      //   this.$toast("投保人名称填写不完整");
      //   return;
      // }
      console.log("policyHolder", policyHolder);
      const nameFlag = this.blurInsurePolic("name", policyHolder, "", true);
      const idCodeFlag = this.blurInsurePolic("idCode", policyHolder);
      const phoneFlag = this.blurInsurePolic("phone", policyHolder);
      const emailFlag = this.blurInsurePolic("email", policyHolder);
      if (nameFlag) {
        errinfos.push("姓名");
      }
      if (idCodeFlag) {
        errinfos.push("证件号");
      }
      if (phoneFlag) {
        errinfos.push("手机号");
      }
      if (emailFlag) {
        errinfos.push("邮箱");
      }
      if (!this.InsuredList.length) {
        this.$toast("请添加被保人！");
        return;
      }
      //投保人年龄
      if (policyHolder.idType != "社会信用代码") {
        let birthdayFlag = false;
        if (!policyHolder.birthDay) {
          this.insureError.birthday = true;
          birthdayFlag = true;
          errinfos.push("出生日期");
        } else {
          let birthday = this.moment(policyHolder.birthDay).format(
            "YYYY-MM-DD"
          );
          let endDate = this.moment(this.step1Data.startTime).format(
            "YYYY-MM-DD"
          );
          let age = util.jsGetAge(birthday, endDate);
          if (age < 18) {
            this.insureError.birthday = true;
            birthdayFlag = true;
            errinfos.push("年龄不足18岁，");
          } else {
            this.insureError.birthday = false;
          }
        }
      }
      this.InsuredList.forEach((el, index) => {
        let flag = false;
        if (!el.name) {
          flag = true;
        } else {
          if (el.name.length < 2) {
            flag = true;
          }
        }
        if (!el.idCode) {
          flag = true;
        } else {
          if (el.idType == "身份证") {
            if (!util.isCardID(el.idCode)) {
              flag = true;
            }
          } else if (el.idType != "身份证") {
            if (!el.idCode) {
              flag = true;
            }
          }
          if (el.idType == "护照") {
            var rega =
              /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
            if (!rega.test(el.idCode)) {
              flag = true;
            }
          } else if (el.idType != "护照") {
            if (!el.idCode) {
              flag = true;
            }
          }
          if (el.idType == "其他") {
            let has = this.isOther(el.idCode);
            if (has) {
              flag = true;
            }
          } else if (el.idType != "其他") {
            if (!el.idCode) {
              flag = true;
            }
          }
        }
        if (el.idType != "社会信用代码") {
          if (!el.birthday) {
            flag = true;
          } else {
            let birthday = this.moment(el.birthday).format("YYYY-MM-DD");
            let endDate = this.moment(this.step1Data.startTime).format(
              "YYYY-MM-DD"
            );
            let age = util.jsGetAge(birthday, endDate);
            if (age > this.endAge || age < this.startAge) {
              flag = true;
            } else {
            }
          }
        } else {
          el.birthday = "";
        }
        if(this.detail.insuranceCompanyId == 17){
          if(!el.relationship){
            flag = true;
          }
        }
        if (flag) {
          beibaoErrinfos.push(index + 1);
        }
      });
      // if(this.detail.insuranceCompanyId == 23 && (this.detail.id == 214 || this.detail.id == 216)){
      //   if(this.InsuredList.length < 3){
      //     this.$toast('本方案仅限3人及以上团体投保!')
      //     return
      //   }
      // }
      for (let i = 0; i < this.InsuredList.length; i++) {
        for (let j = i + 1; j < this.InsuredList.length; j++) {
          if (
            this.InsuredList[i].idCode &&
            this.InsuredList[j].idCode &&
            this.InsuredList[i].idCode == this.InsuredList[j].idCode
          ) {
            if (this.InsuredList[i].idType == "身份证") {
              this.$toast("被保人证件号码重复，请检查!");
              return;
              continue;
            } else if (this.InsuredList[i].idType == "护照") {
              this.$toast("被保人证件号码重复，请检查!");
              return;
              continue;
            } else {
              if (this.InsuredList[j].idCode != "") {
                this.$toast("被保人证件号码重复，请检查!");
                return;
                continue;
              }
            }
          }
        }
      }

      if (errinfos.length || beibaoErrinfos.length) {
        Dialog.alert({
          title: "提示",
          message: `${
            errinfos.length ? "投保人" + errinfos.join(",") + "有误," : ","
          }${
            beibaoErrinfos.length
              ? "第" + beibaoErrinfos.join(",") + "行被保人信息有误"
              : ""
          }`,
        }).then(() => {});
      }

      if (errinfos.length || beibaoErrinfos.length) {
        return;
      }
      
      //检测被保人
      try {
        // this.payBanFlag = true
        
        //保存常用被保人信息
        if(this.saveInsuredFlag){
          await this.saveCommonInsures();
        }

        await this.calculateOrder();
        await this.batchAdd()
      } catch (error) {
        this.$toast.clear()
        if(error && error.msg){
          this.$toast(error.msg);
        }
      }
    },
    async calculateOrder() {
      if(!this.step1Data.startTime || !this.step1Data.endTime || this.InsuredList.length <= 0){
        this.price = 0;
        this.totalPricePay = 0;
        return;
      }
      let params = JSON.parse(JSON.stringify(this.step1Data));
      console.log("params", params);
      let res = await this.$http.post("api/bill/calculate", {
        accountId: this.$route.query.accountId,
        subAccountId:0,
        companyId: this.$route.query.companyId,
        startDate: moment(this.step1Data.startTime).valueOf(),
        endDate: moment(this.step1Data.endTime).valueOf(),
        productId: this.id,
        index: this.step1Data.planIndex,
        size: this.InsuredList.length,
        startAge: this.startAge,
        endAge: this.endAge,
        
      });
      console.log("this.InsuredList.length", this.InsuredList);
      console.log(res);
      if (res && res.code == 0) {
        this.price = res.t.payPrice;
        this.totalPricePay = res.t.total;
      } else {
        if(res && res.msg){
          this.$toast.fail(res.msg);
        }
      }
    },
    async batchAdd(MarKing) {
      if (this.detail.hasDestnation) {
        if (!this.step1Data.planAddr) {
          this.$toast("请选择目的地！");
          return;
        }
      }
      let insurePeople = JSON.parse(JSON.stringify(this.checkPolicy));
      let InsuredList = JSON.parse(JSON.stringify(this.InsuredList));
      console.log("insurePeople",insurePeople)
      InsuredList.forEach((el) => {
        //性别number 网络错误
        el.sex = String(el.sex);
      });
      InsuredList.forEach((el) => {
        if (el.hasOwnProperty("currentDate")) {
          delete el["currentDate"];
        }
      });
      if (insurePeople.hasOwnProperty("birthDayTime")) {
        delete insurePeople["birthDayTime"];
      }
      if (insurePeople.hasOwnProperty("birthDay")) {
        //可能需要修改日期格式
        insurePeople.birthday = moment(insurePeople.birthDay).valueOf();
        delete insurePeople["birthDay"];
      }
      if (insurePeople.hasOwnProperty("currentDate")) {
        delete insurePeople["currentDate"];
      }
      insurePeople.sex = insurePeople.sex == "男" ? 1 : insurePeople.sex == 1 ? 1 : 2
      let together = 0
      // || (this.detail.insuranceCompanyId == 25 && this.detail.id == 226) 
      if((((this.detail.insuranceCompanyId == 23 && (this.detail.id == 213 ||  this.detail.id == 218 || this.detail.id == 214 || this.detail.id == 216)) || (this.detail.insuranceCompanyId == 25 && this.detail.id == 114)) && this.InsuredList.length < 3 ) || this.detail.insuranceCompanyId == 17){
        together = 0
      }else{
        together = 1
      }


      console.log("params-------1", InsuredList,this.detail.insuranceCompanyId,this.productId);

      if(this.detail.insuranceCompanyId == 25 && this.detail.id == 226){
        together = InsuredList.length <= 2 ? 0 : 1;
      }
      let params = {
        accountId: this.$route.query.accountId,
        subAccountId:0,
        companyId: this.$route.query.companyId,
        together: together,
        insurePeople: JSON.stringify(insurePeople),
        startDate: moment(this.step1Data.startTime).valueOf(),
        endDate: moment(this.step1Data.endTime).valueOf(),
        payType: 1, //1,现金，2信用
        productId: this.id,
        remark: "",
        index: this.step1Data.planIndex, //保险计划的索引
        destination: this.step1Data.planAddr, //目的地
        infos: JSON.stringify(InsuredList),
        insureType: 2,
        language: "CN",
        startAge: this.startAge,
        endAge: this.endAge,
        source: 2,
        IsCps: 1,
        qrCodeId:this.$route.query.id,
      };
      console.log("params-------2", params);

      params.MarKing = MarKing || '';
      this.$toast({
          type: "loading",
          message: "订单创建中...",
          forbidClick: true,
          overlay: true,
          duration: 0,
          loadingType: "spinner"
      });
      let addRes = await this.$http.post("api/bill/batchAdd", params);

      let ids = [];
      if (addRes.code == 0) {
        // this.payBanFlag = false
        this.$toast.clear()
        // if(this.openBalance == 1){
        //   this.payType = 3
        // }else 
        addRes.t.forEach((item, i) => {
          ids.push(item.id);
        });
        this.orderIds = ids;
        if(this.$route.query.accountId == 13081 || this.openBalance == 1){
          this.payType = 3
        }else{
          this.payType = 1
        }
        if(this.openBalance == 1 && this.openWeChatPay == 0){
          this.payType = 3;
          this.payOrder();
        }else{
          this.isShowPay = true;
        }
      }else if(addRes.code >= 10 && addRes.code <= 15) {
        this.$toast.clear()
          Dialog.confirm({
            title: '提示',
            message: `${addRes.msg}`,
            confirmButtonText:'继续购买',
            cancelButtonText:'返回修改',
            showConfirmButton: this.enableGotoBuy(this.id),
          }).then(() => {
              this.batchAdd(addRes.code)
          }).catch(() => { });
      }  else {
          this.$toast.clear()
          if(addRes && addRes.msg){
            this.$toast.fail(addRes.msg);
          }
      } 
    },
    enableGotoBuy(matchId){
      if(this.repeatBuy != undefined){
        return this.repeatBuy == 1 ? true : false;
      }
      if(this.$route.query.accountId == 18564 || this.$route.query.accountId == 19018){
        return true;
      }else if(this.$route.query.accountId == 39149 || this.$route.query.accountId == 41773 || this.$route.query.accountId == 51031){
        return false;
      }
      if(matchId){
        let pId = parseInt(matchId);
        let ids = [156, 168, 169, 170, 172, 119];
        if(ids.indexOf(pId) != -1){
          return true;
        }
      }
      return false;
    },
    async buildBill(ids) {
      if(this.allow){
        return
      }
      this.allow = true
      if (this.openBalance == "1" && this.whetherPayCode == "1" && this.payType == 3) {
        let key = CryptoJS.enc.Utf8.parse("z1ijn$dk89dl#ers");
        let srcs = CryptoJS.enc.Utf8.parse(this.paymentCodePwd);
        let iv = CryptoJS.enc.Utf8.parse("12abtrefgabcdefg");
        let encrypted = CryptoJS.AES.encrypt(srcs, key, {
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
          iv: iv,
        });
        let password = encodeURIComponent(encrypted.toString());
        this.$toast({
          type: "loading",
          // message: "订单支付中...",
          message: "处理中...",
          forbidClick: true,
          overlay: true,
          duration: 0,
          loadingType: "spinner"
        });
        axios.post("api/accountBill/buildBill", {
            accountId: this.$route.query.accountId,
            // subAccountId: this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id,
            subAccountId:0,
            together: 1,
            companyId: this.$route.query.companyId,
            payType: this.payType,
            relationBillIds: JSON.stringify(ids),
            opName: !!this.info.name ? this.info.name : "自主购买",
            summary: this.detail.title,
            qrCodeId: this.$route.query.id ? this.$route.query.id : '',
            remark: "",
            paymentCodePwd: decodeURIComponent(password),
            source: 2,
            // sourece:5
          })
          .then((res) => {
            this.allow = false
            if (res && res.code == 0) {
              this.billId = res.t.id;
              this.payMoneyFlag = false;
              this.$toast.clear()
              Dialog.confirm({
                title: "提示",
                message: this.openBalance == 1 && this.openWeChatPay == 0 ? "已成功领取保险" : "购买成功",
              }).then(() => {
                  this.$router.push({
                    name: "CpsOrder",
                    query: {
                      accountId:this.$route.query.accountId,
                      companyId:this.$route.query.companyId,
                      id:this.$route.query.id,
                      fixedOrNot: this.loadList.fixedOrNot, //1使用固定投保人 0不使用固定投保人
                      showBalance: this.showBalance,
                      // c:this.$route.query.c
                    },
                  });
                })
                .catch(() => {});
            } else {
              if(res && res.msg){
                this.$toast.fail(res.msg);
              }
              this.paymentCodePwd = "";
            }
          })
          .catch((err) => {
            console.log(err);
            this.allow = false
            if(err && err.msg){
              this.$toast.fail(err.msg);
            }
          });
      } else {
        this.orderIds = JSON.stringify(ids);
         this.$toast({
          type: "loading",
          // message: "订单生成中...",
          message: "处理中...",
          forbidClick: true,
          overlay: true,
          duration: 0,
          loadingType: "spinner"
        });
        let res = await this.$http.post("api/accountBill/buildBill", {
          accountId: this.$route.query.accountId,
          // subAccountId: this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id,
          subAccountId:0,
          together: 1,
          companyId: this.$route.query.companyId,
          payType: this.payType,
          relationBillIds: JSON.stringify(ids),
          opName: !!this.info.name ? this.info.name : "自主购买",
          summary: this.detail.title,
          qrCodeId: this.$route.query.id ? this.$route.query.id : '',
          remark: "",
          source: 2,
        });
        let flag = true;
        this.allow = false
        if (res && res.code == 0) {
          this.$toast.clear()
          this.billId = res.t.id;
          flag = true;
          if (this.payType == 3 || this.payType == 2) {
            // this.$toast({
            //   type: "loading",
            //   message: "订单支付中...",
            //   forbidClick: true,
            //   overlay: true,
            //   duration: 0,
            //   loadingType: "spinner"
            // });
            // this.$toast.clear()
            Dialog.confirm({
              title: "提示",
              message: this.openBalance == 1 && this.openWeChatPay == 0 ? "已成功领取保险" : "购买成功",
            }).then(() => {
                this.$router.push({
                  name: "CpsOrder",
                  query: {
                    accountId:this.$route.query.accountId,
                    companyId:this.$route.query.companyId,
                    id:this.$route.query.id,
                    fixedOrNot: this.loadList.fixedOrNot, //1使用固定投保人 0不使用固定投保人
                    showBalance: this.showBalance,
                    // c:this.$route.query.c
                  },
                });
              })
              .catch(() => {});
            flag = false;
          }
        } else {
          this.$toast.clear()
          this.allow = false
          if(res && res.msg){
            this.$toast.fail(res.msg);
          }
          flag = false;
        }
        setTimeout(()=>{
          this.allow = false
        },1000)
        return flag;
      }
    },
    async init() {
      await this.getLoad();
      
      // await this.getBaseInfo();
      // await this.getDetail();
      if (location.href.indexOf("http://localhost") != -1) {
      } else if (this.$page.isInWechat) {
        wechatService.auth(
          0,
          ({ openid, unionid }) => {
            if (!!openid && !!unionid) {
              this.unionId = unionid;
              this.openId = openid;
              // this.shareConfig();
            }
          },
          false
        );
      }
      // if (!this.detail.canTodayBuy) {
      //   this.minDate = new Date(new Date().getTime() + 86400000);
      // }else{
      //   this.minDate = new Date();
      // }
      console.log("this.detail.hasDestnation",this.detail.hasDestnation)
      console.log("this.detail",this.detail)
      console.log("this.loadList",this.loadList)
      setTimeout(() => {
        this.showTip = false;
      }, 5000);
    },
    async getLoad() {
      //获取产品信息
      let res = await this.$http.post("/api/insuranceQrCode/get", {
        id: this.$route.query.id,
      });
      if (res && res.code == 0) {
        let loadList = res.t;
        this.openBalance = res.t.openBalance;
        if(res.t.openWeChatPay){
          this.openWeChatPay = res.t.openWeChatPay
        }
        this.whetherPayCode = res.t.whetherPayCode;
        this.showBalance = res.t.showBalance;
        this.repeatBuy = res.t.repeatBuy;
        if (loadList.fixedOrNot == "1") {
          let insurePeople = JSON.parse(loadList.insurePeople);
          if (insurePeople.idType != "社会信用代码") {
            this.policyHolder = {
              name: insurePeople.name,
              pinyin: insurePeople.pinyin || "",
              idType: insurePeople.idType,
              idCode: insurePeople.idCode,
              sex: insurePeople.sex == 1 ? "男" : "女",
              birthDay: this.moment(insurePeople.birthDate).format("YYYY-MM-DD"),
              phone: insurePeople.phone,
              email: insurePeople.email || "",
            };
          } else {
            this.policyHolder = {
              name: insurePeople.name,
              idType: insurePeople.idType,
              idCode: insurePeople.idCode,
              phone: insurePeople.phone,
              email: insurePeople.email || "",
            };
          }
        }
        // if(loadList.riskNotification == "1"){
        //   loadList.riskNotificationUrl = JSON.parse(loadList.riskNotificationUrl);
        // }
        this.id = loadList.productId.toString();
        this.loadList = res.t;
        await this.getDetail(loadList.productId);
      } else {
        if(res && res.msg){
          this.$toast.fail(res.msg);
        }
      }
    },
    shareConfig() {
      // console.log(this.publicData.accountBasic.shareUrl)
      let shareUrl = "";
      let wxShareConfig = {};
      if (this.publicData.accountBasic.shareUrl) {
        wxShareConfig = {
          title: this.detail.title,
          desc: this.detail.insuranceCompany + "-" + this.detail.tags,
          imgUrl: this.detail.poster,
          link:
            "http://cps1.baojbx.com/detail?id=" +
            this.$route.query.id +
            "&c=" +
            this.publicData.accountBasic.shareUrl,
        };
      } else {
        wxShareConfig = {
          title: this.detail.title,
          desc: this.detail.insuranceCompany + "-" + this.detail.tags,
          imgUrl: this.detail.poster,
          link: location.href,
        };
      }
      console.log("wxShareConfig", wxShareConfig);
      wechatService.jsapi(0, wxShareConfig, [
        "onMenuShareTimeline",
        "onMenuShareAppMessage",
      ]);
    },
    changeselectPlans(name, title) {
      console.log(name, title);
      this.selectModel.selectPlans = name;
      this.summarys = this.detail.plans[name].summarys;
    },
    changeselectTime(index) {
      this.selectModel.selectTime = index;
    },
    changeselectAge(index) {
      this.selectModel.selectAge = index;
    },
    // changePdfPage(num){
    //   console.log("num",num)
    //   // this.pageCount = this.pageCount++
    // },
    // 切换页数
    changePdfPage(val) {
      if (val === "pre" && this.currentPage > 1) {
        // 切换后页面回到顶部
        this.currentPage--;
      } else if (val === "next" && this.currentPage < this.pageCount) {
        this.currentPage++;
      } else if (val === "first") {
        this.currentPage = 1;
      } else if (val === "last" && this.currentPage < this.pageCount) {
        this.currentPage = this.pageCount;
      }
    },
    async getDetail(id) {
      //获取产品信息
      let url = "api/insuranceProduction/getByCode";
      if (this.id.length < 8) {
        url = "api/insuranceProduction/get";
      }
      let res = await this.$http.post(url, { id: id });
      if (res && res.code == 0) {
        let detail = res.t;
        // document.title = "希望保-" + detail.title
        detail.plans = JSON.parse(detail.plans)
        detail.files = JSON.parse(detail.files)
        if (detail.plans.length > 3) {
          this.showTip = true;
        }
        try {
          detail.summarys = JSON.parse(detail.summarys);
          detail.summarys.forEach((item, index) => {
            item = item.split("：");
            detail.summarys[index] = item;
            console.log(item);
          });
        } catch (error) {}
        if (detail.hasDestnation) {
          try {
            detail.goDestnations = JSON.parse(detail.goDestnations);
          } catch (error) {
            detail.goDestnations = [];
          }
        }
        if(detail.hasDestnation == 1) {
          if(detail.goDestnations && detail.goDestnations.length == 1){
            this.step1Data.planAddr = detail.goDestnations[0];
            this.destinationArr = [this.step1Data.planAddr];
          }else{
            this.step1Data.planAddr = ""
          }
        }else{
          this.step1Data.planAddr = "中国大陆"
        }
        try {
          detail.serviceFiles = JSON.parse(detail.serviceFiles);
        } catch (error) {}
        try {
          detail.customerFiles = JSON.parse(detail.customerFiles);
        } catch (error) {}

        if (detail.noticePdf) {
          try {
            detail.noticePdf = JSON.parse(detail.noticePdf);
            if (detail.noticePdf.length) {
              this.noticePdfFlag = true;
            }
          } catch (error) {}
        }
        let ageArr = [];
        detail.plans[0].cycle.forEach((el) => {
          ageArr.push({
            start: el.startAge,
            end: el.endAge,
          });
        });
        for (let i = ageArr.length; i > 0; i--) {
          for (let j = i - 1; j > -1; j--) {
            if (JSON.stringify(ageArr[i]) === JSON.stringify(ageArr[j])) {
              ageArr.splice(j, 1);
            }
          }
        }
        // let setAge = ageArr
        let planAge = [];
        if (ageArr.length <= 1) {
          this.planageFlag = 0;
          ageArr.forEach((item, index) => {
            this.step1Data.planAge = item.start + "-" + item.end + "周岁";
          });
        } else {
          this.planageFlag = 1;
          ageArr.forEach((item, index) => {
            planAge.push(item.start + "-" + item.end + "周岁");
          });
          this.planAges = planAge;
          this.step1Data.planAge = this.planAges[0];
        }
        let startAgeIndex = this.step1Data.planAge.indexOf("-");
        this.startAge = this.step1Data.planAge.substring(0, startAgeIndex);
        this.endAge = this.step1Data.planAge.slice(-4, -2);
        // this.setAges = ageArr;
        if (this.loadList.plan != "不指定") {
          this.plans = this.loadList.plan.split(",");
        } else {
          console.log("detail.plans", detail.plans);
          detail.plans.forEach((item, index) => {
            this.plans.push(item.name);
          });
        }
        this.step1Data.planName = this.plans[0];
        detail.plans.forEach((item,index)=>{
            if(this.step1Data.planName == item.name){
              this.summarys = item.summarys
              this.step1Data.planIndex = index;
            }
        })
        console.log("this.plans", this.plans);
        let timeArr = [];
        let newArr = [];
        detail.plans[this.step1Data.planIndex].cycle.forEach((el) => {
          if (el.startAge == ageArr[0].start && el.endAge == ageArr[0].end) {
            timeArr.push(el);
          }
        });
        if (this.loadList.insureDays != "不默认") {
          this.planDays = this.loadList.insureDays.split(",");
          this.step1Data.planDay = this.planDays[0];
        } else {
          timeArr.forEach((item, index) => {
            if (item.start != item.end && item.end != 365) {
              item.date = `${item.start}-${item.end}天`;
            } else if (item.start == item.end && item.end != 365) {
              item.date = `${item.start}天`;
            } else if (item.end == 365 || item.end == 366) {
              item.date = `1年`;
            }
            newArr.push(item.date);
            var newArr2 = newArr.filter(function (item, index) {
              return newArr.indexOf(item) === index; // 因为indexOf 只能查找到第一个
            });
            this.planDays = newArr2;
            this.step1Data.planDay = this.planDays[0];
          });
        }
        this.setTimes = timeArr;
        document.title = detail.title
        if (detail.todayBuyMin) {
          this.todayBuyMin = Math.floor(detail.todayBuyMin / 60) + "小时" + (detail.todayBuyMin % 60) + "分";
        }else{
          this.todayBuyMin = 0;
        }
        let daysIndex = "";
        let result = new Date().getTime();
        if (this.step1Data.planDay.includes("-")) {
            let resolveEndDay = this.step1Data.planDay.match(/-(\S*)天/)[1];
            daysIndex = resolveEndDay;
        }else if(this.step1Data.planDay == "1年"){
            let dayIndex = this.step1Data.planDay.lastIndexOf("年");
            var resolveStartDay = this.step1Data.planDay.substring(0, dayIndex);
            daysIndex = 365;
        } else {
            let dayIndex = this.step1Data.planDay.lastIndexOf("天");
            var resolveStartDay = this.step1Data.planDay.substring(0, dayIndex);
            daysIndex = resolveStartDay;
        }
        console.log("daysIndex",daysIndex)
        let dddddtime = "";
        if(this.loadList.effectiveType == 3) {
          if(this.loadList.fixedStartTime < new Date().getTime()){
            Dialog.confirm({
              title: "提示",
              message: '当前时间不支持购买此订单，请联系商家处理',
              showConfirmButton: false,
              showCancelButton: false,
            })
            .then(() => {})
            .catch(() => {});
            return
          }
          this.step1Data.startTime = moment(this.loadList.fixedStartTime).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/");
          if (!detail.canTodayBuy) {
            let end = this.loadList.fixedStartTime + daysIndex * 86400000 - 1000;
            this.step1Data.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
          } else {
            let nextDay = new Date(this.step1Data.startTime).getTime()
            if(this.detail.insuranceCompanyId == 8 || this.detail.insuranceCompanyId == 13 || this.detail.insuranceCompanyId == 27){
              let end = nextDay + daysIndex * 86400000 - 1000;
              this.step1Data.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
            }else{
              if(daysIndex == 365 || daysIndex == 366){
                let endDate = nextDay + (86400000 * daysIndex - 1000);
                let dataTim = new Date(endDate)
                let dataStartTim = new Date(nextDay)
                let year = dataTim.getFullYear()
                let month = dataStartTim.getMonth() + 1 < 10 ? "0" + (dataStartTim.getMonth() + 1) : dataStartTim.getMonth() + 1
                let dayDate = dataStartTim.getDate() < 10 ? "0" + dataStartTim.getDate() : dataStartTim.getDate();
                let dateTimer = year + "/" + month + "/" + dayDate + ' ' + dataStartTim.getHours() + ':' + dataStartTim.getMinutes()+':' + dataStartTim.getSeconds()
                console.log("dateTimer",dateTimer)
                let endTime = new Date(dateTimer).getTime() - 1000
                this.step1Data.endTime = moment(endTime).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
              }else{
                let end = nextDay + daysIndex * 86400000 - 1000;
                this.step1Data.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
              }
            }
          }
          dddddtime = new Date(this.step1Data.startTime);
        }else if (this.loadList.effectiveType == 2) {
          let nowTime = new Date().getTime();
          let startMax = "";
          if (!detail.canTodayBuy) {
            let tomorrowDate = new Date(nowTime + 86400000)
            tomorrowDate.setHours(0,0,0);  // 清除时分秒
            tomorrowDate = tomorrowDate.getTime()
            this.step1Data.startTime = moment(tomorrowDate).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
            let end = tomorrowDate + daysIndex * 86400000 - 1000;
            this.step1Data.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
            startMax =  moment(tomorrowDate).format("YYYY-MM-DD")
            this.minDate = new Date(tomorrowDate)
          } else {
            let todayBuyMin = 3600000;
            todayBuyMin = detail.todayBuyMin * 60 * 1000;
            let startTim = nowTime + todayBuyMin
            this.minDate = new Date(startTim)
            this.step1Data.startTime = moment(startTim).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
            let nextDay = new Date(this.step1Data.startTime).getTime()
            // this.step1Data.startTime = moment(nextDay).format("YYYY-MM-DD HH:mm:ss")
            if(this.detail.insuranceCompanyId == 8 || this.detail.insuranceCompanyId == 13 || this.detail.insuranceCompanyId == 27){
              let end = nextDay + daysIndex * 86400000 - 1000;
              this.step1Data.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
            }else{
              if(daysIndex == 365 || daysIndex == 366){
                // let startTime = new Date(this.step1Data.startTime).getTime()
                let endDate = nextDay + (86400000 * daysIndex - 1000);
                let dataTim = new Date(endDate)
                let dataStartTim = new Date(nextDay)
                let year = dataTim.getFullYear()
                let month = dataStartTim.getMonth() + 1 < 10 ? "0" + (dataStartTim.getMonth() + 1) : dataStartTim.getMonth() + 1
                let dayDate = dataStartTim.getDate() < 10 ? "0" + dataStartTim.getDate() : dataStartTim.getDate();
                // let dateTimer = year + "-" + month + "-" + dayDate + ' ' + '23:59:59'
                let dateTimer = year + "/" + month + "/" + dayDate + ' ' + dataStartTim.getHours() + ':' + dataStartTim.getMinutes()+':' + dataStartTim.getSeconds()
                console.log("dateTimer",dateTimer)
                let endTime = new Date(dateTimer).getTime() - 1000
                this.step1Data.endTime = moment(endTime).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
                console.log("this.step1Data.endTime",this.step1Data.endTime)
              }else{
                // let end = nextDay + daysIndex * 86400000 - 1000;
                // this.step1Data.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss");
                let endTim = startTim + (86400000 * daysIndex - 1000);
                this.step1Data.endTime = moment(endTim).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
                startMax = this.moment(startTim).format("YYYY-MM-DD")
              }
            }
            // let todayBuyMin = 3600000;
            // todayBuyMin = detail.todayBuyMin * 60 * 1000;
            // let startTim = nowTime + todayBuyMin
            // this.minDate = new Date(startTim)
            // this.step1Data.startTime = moment(startTim).format("YYYY-MM-DD HH:mm:ss")
            // let endTim = startTim + (86400000 * daysIndex - 1000);
            // this.step1Data.endTime = moment(endTim).format("YYYY-MM-DD HH:mm:ss")
            // startMax = this.moment(startTim).format("YYYY-MM-DD")
          }
          dddddtime = new Date(this.step1Data.startTime)
        }else{
          let nowTime = new Date().getTime()
          if (!detail.canTodayBuy) {
            let tomorrowDate = new Date(nowTime + 86400000)
            tomorrowDate.setHours(0,0,0);  // 清除时分秒
            tomorrowDate = tomorrowDate.getTime()
            this.minDate = new Date(tomorrowDate);
          } else {
            let todayBuyMin = 3600000;
            todayBuyMin = detail.todayBuyMin * 60 * 1000;
            let startTim = nowTime + todayBuyMin
            this.minDate = new Date(startTim)
          }
          dddddtime = nowTime
        }
        let year = moment(dddddtime).format("YYYY");
        let month = moment(dddddtime).format("MM");
        let day = moment(dddddtime).format("DD");
        let endAge = new Date(year - this.endAge - 1, month - 1, day);
        let endage1 = moment(endAge.getTime() + 86400000).format("YYYY-MM-DD");
        this.InsuredModelMaxDate = new Date(year - this.startAge,month - 1,day);
        this.InsuredModelMinDate = new Date(endage1);
        
        if(detail.insuranceCompanyId != 17){
          this.idTypeOptions = ["社会信用代码", "身份证", "护照", "其他"];
        }else{
          this.idTypeOptions = ["身份证", "护照", "其他"];
        }
        if(detail.insuranceCompanyId == 26){
        this.idTypeOptions = ["社会信用代码", "身份证", "护照", "港澳居民来往内地通行证","台湾居民来往内地通行证"];
        this.idTypeOption = ["身份证", "护照","港澳居民来往内地通行证","台湾居民来往内地通行证"]
      }else{
        this.idTypeOptions = ["社会信用代码", "身份证", "护照", ,"其他"];
        this.idTypeOption = ["身份证", "护照","其他"]
      }
        this.detail = detail
        console.log("detail-----",this.detail)
        console.log("this.InsuredModelMinDate",this.InsuredModelMinDate)
        console.log("this.InsuredModelMaxDate",this.InsuredModelMaxDate)
      } else {
        if(res && res.msg){
          this.$toast.fail(res.msg);
        }
      }
    },
    /**
     * 获取基本信息
     */
    // async getBaseInfo() {
    //   //获取基本信息
    //   if(this.publicData && this.publicData.id){
    //     let accountId = 'BJ' + (this.publicData.id * 123 + 123) + 'ID' 
    //     console.log("accountId",accountId)
    //     let res = await this.$http.post("api/accountLogin/basicInfo", {
    //       accountId:accountId
    //     });
    //     if (res && res.code == 0) {
    //       this.info = res.t;
    //     }
    //   }
    // },
    //被保人
    openInsured(type, data, index) {
      this.openInsureType = type;
      this.openInsureIndex = index;
      if (type == "add") {
        if (this.InsuredList.length > 4) {
          this.changeCheck = 0;
          this.$toast("最多可以填写五个被保险人！");
          return;
        } else {
          this.changeCheck = 1;
        }
        if(this.detail.insuranceCompanyId == 17){
          this.InsuredModel = {
            name: "",
            pinyin: "",
            idType: "身份证",
            idCode: "",
            sex: "男",
            birthDay: "",
            birthDayTime: "",
            relationship:"",
            phone: "",
            currentDate: "",
          };
        }else{
          this.InsuredModel = {
            name: "",
            pinyin: "",
            idType: "身份证",
            idCode: "",
            sex: "男",
            birthDay: "",
            birthDayTime: "",
            phone: "",
            currentDate: "",
          };
        }
      } else {
        this.changeCheck = 1;
        data = JSON.parse(JSON.stringify(data));
        console.log("data--->", data);
        if(this.detail.insuranceCompanyId == 17){
          this.InsuredModel = {
            name: data.name,
            pinyin: data.pinyin || "",
            idType: data.idType,
            idCode: data.idCode,
            sex: data.sex == 1 ? "男" : "女",
            birthDay: data.birthday ? moment(data.birthday).format("YYYY-MM-DD") : "",
            birthDayTime: data.birthday,
            relationship:data.relationship,
            phone: data.phone,
            currentDate: data.birthday ? new Date(data.birthday) : "",
          };
        }else{
          this.InsuredModel = {
            name: data.name,
            pinyin: data.pinyin || "",
            idType: data.idType,
            idCode: data.idCode,
            sex: data.sex == 1 ? "男" : "女",
            birthDay: data.birthday
              ? moment(data.birthday).format("YYYY-MM-DD")
              : "",
            birthDayTime: data.birthday,
            phone: data.phone,
            currentDate: data.birthday ? new Date(data.birthday) : "",
          };
        }
      }
      console.log("this.InsuredModel", this.InsuredModel);
    },
    openSelectAddr() {
      // if (!this.step1Data.startTime) {
      //   this.$toast("请选择起保日期！");
      //   this.step1DataError.startTime = true
      //   return
			// }else{
        this.$refs.selectAddr.isShow = true;
      // }
    },
    changeIsReady1Index(index) {
      if (index == 1) {
        this.isReady1Index = String(2);
        this.isReady1Arr[0] = 1;
      }
      if (index == 2) {
        this.isReady1Index = String(3);
        this.isReady1Arr[1] = 1;
      }
      if (index == 3) {
        this.isReady1Arr[2] = 1;
        this.isReady1Flag = false;
        this.isReady1 = true;
      }
    },
    closedIsReady1() {
      this.isReady1Arr.forEach((el, i) => {
        if (!el) {
          this.isReady1 = false;
        }
      });
    },
    chageReady1(val) {
      //投保新规则
      if (val) {
        this.isReady1Arr.forEach((el, i) => {
          if (!el) {
            this.isReady1Flag = true;
            this.isReady1Arr[0] = 1;
          }
        });
      }
    },
    noticePdfCancel() {
      this.noticePdfFlag = false;
      this.noticePdfFlag1 = true;
    },
    noticePdfCheck() {
      if (this.noticePdfFlag1) {
        setTimeout(() => {
          this.noticePdfFlag = true;
        }, 100);
        return true;
      } else {
        return false;
      }
    },
    gotoPreview(type) {
      if (type == 1) {
        this.$router.push({
          name: "Preview",
          params: {
            id: this.detail.id,
          },
          query: {
            type: type,
          },
        });
      }
      if (type == 2) {
        this.$router.push({
          name: "Preview",
          params: {
            id: this.detail.id,
          },
          query: {
            type: type,
          },
        });
      }
    },
    preview(url, filename) {
      this.regPdfFUrl = pdf.createLoadingTask(url);
      this.regPdfFlag = true;
      console.log(url, filename);
      // this.getBlob(url,  (blob)=> {
      //     this.previewAS(blob, filename);
      // });
    },
    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    },
    // 投保人验证
    blurInsure(type, val, toast, fuzhiFlag) {
      if (type == "name") {
        if (this.policyHolder.idType == "社会信用代码") {
          let regs = /^[\u4e00-\u9fa5()（）]+$/;
          if (!regs.test(this.policyHolder["name"])) {
            this.insureError.name = true;
            if (toast == true) {
              this.$toast("姓名格式不正确");
            }
            return true;
          } else {
            this.insureError.name = false;
            return false;
          }
        } else {
          let reg = /^[a-zA-Z\/ ]{2,20}$/;
          let regs = /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/;
          if (val == "") {
            this.insureError.name = true;
            if (toast == true) {
              this.$toast("投保人姓名有误");
            }
            return true;
          } else if (this.policyHolder["name"].length < 2) {
            this.insureError.name = true;
            if (toast == true) {
              this.$toast("姓名填写不完整");
            }
            return true;
          } else if (!regs.test(this.policyHolder["name"])) {
            this.insureError.name = true;
            if (toast == true) {
              this.$toast("姓名格式不正确");
            }
            return true;
          } else if (reg.test(this.policyHolder["name"])) {
            this.policyHolder["name"] = this.policyHolder["name"].toUpperCase();
            if (!fuzhiFlag) {
              this.idTypeOptions = ["护照", "其他"];
              this.policyHolder["idType"] = "护照";
            }
          } else {
            this.policyHolder["pinyin"] = loadPinYinInit.ConvertPinyin(
              this.policyHolder["name"]
            );
            this.insureError.name = false;
            // this.idTypeOptions = ["社会信用代码", "身份证", "护照", "其他"];
            if(this.detail.insuranceCompanyId != 17){
              this.idTypeOptions = ["社会信用代码", "身份证", "护照", "其他"];
            }else{
              this.idTypeOptions = ["身份证", "护照", "其他"];
            }
            return false;
          }
        }
      }
      if (type == "pinyin") {
        if (val == "") {
          this.insureError.pinyin = true;
          if (toast == true) {
            this.$toast("投保人拼音有误");
          }
          return true;
        } else {
          this.insureError.pinyin = false;
          return false;
        }
      }
      if (type == "idCode") {
        if (this.policyHolder.idType == "身份证") {
          if (!util.isCardID(val)) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("投保人证件号有误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        } else if (this.policyHolder.idType == "护照") {
          let PassportNumberReg =
            /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
          if (!PassportNumberReg.test(val)) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("护照号码格式错误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        } else if (this.policyHolder.idType == "其他") {
          let has = this.isOther(val);
          if (has) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("证件格式错误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        } else if (this.policyHolder.idType != "身份证") {
          if (!val) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("投保人证件号有误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        }
      }
      if (type == "phone") {
        if (!util.isPone(val)) {
          if (toast == true) {
            this.$toast("投保人手机号有误");
          }
          this.insureError.phone = true;
          return true;
        } else {
          this.insureError.phone = false;
          return false;
        }
      }
      if (type == "email") {
        if(val){
          val = val.trim();
          this.policyHolder.email = val;
        }
        if (val && !util.isEmail(val)) {
          if (toast == true) {
            this.$toast("投保人邮箱有误");
          }
          this.insureError.email = true;
          return true;
        } else {
          this.insureError.email = false;
          return false;
        }
      }
    },
    blurInsurePolic(type, val, toast, fuzhiFlag) {
      if (type == "name") {
        if (val.idType == "社会信用代码") {
          let regs = /^[\u4e00-\u9fa5()（）]+$/;
          if (!regs.test(val.name)) {
            this.insureError.name = true;
            if (toast == true) {
              this.$toast("姓名格式不正确");
            }
            return true;
          } else {
            this.insureError.name = false;
            return false;
          }
        } else {
          let reg = /^[a-zA-Z\/ ]{2,20}$/;
          let regs = /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/;
          if (val.name == "") {
            this.insureError.name = true;
            if (toast == true) {
              this.$toast("投保人姓名有误");
            }
            return true;
          } else if (val.name.length < 2) {
            this.insureError.name = true;
            if (toast == true) {
              this.$toast("姓名填写不完整");
            }
            return true;
          } else if (!regs.test(val.name)) {
            this.insureError.name = true;
            if (toast == true) {
              this.$toast("姓名格式不正确");
            }
            return true;
          } else if (reg.test(val.name)) {
            val.name = val.name.toUpperCase();
            if (!fuzhiFlag) {
              this.idTypeOptions = ["护照", "其他"];
              val.idType = "护照";
            }
          } else {
            val.pinyin = loadPinYinInit.ConvertPinyin(val.name);
            this.insureError.name = false;
            this.idTypeOptions = ["社会信用代码", "身份证", "护照", "其他"];
            return false;
          }
        }
      }
      if (type == "pinyin") {
        if (val.pinyin == "") {
          this.insureError.pinyin = true;
          if (toast == true) {
            this.$toast("投保人拼音有误");
          }
          return true;
        } else {
          this.insureError.pinyin = false;
          return false;
        }
      }
      if (type == "idCode") {
        if (val.idType == "身份证") {
          if (!util.isCardID(val.idCode)) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("投保人证件号有误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        } else if (val.idType == "护照") {
          let PassportNumberReg =
            /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
          if (!PassportNumberReg.test(val.idCode)) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("护照号码格式错误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        } else if (val.idType == "其他") {
          let has = this.isOther(val.idCode);
          if (has) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("证件格式错误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        } else if (val.idType != "身份证") {
          if (!val.idCode) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("投保人证件号有误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        }
      }
      if (type == "birthday") {
      }
      if (type == "phone") {
        if (!util.isPone(val.phone)) {
          if (toast == true) {
            this.$toast("投保人手机号有误");
          }
          this.insureError.phone = true;
          return true;
        } else {
          this.insureError.phone = false;
          return false;
        }
      }
      if (type == "email") {
        if(val.email){
          val.email = val.email.trim();
        }
        if (val.email && !util.isEmail(val.email)) {
          if (toast == true) {
            this.$toast("投保人邮箱有误");
          }
          this.insureError.email = true;
          return true;
        } else {
          this.insureError.email = false;
          return false;
        }
      }
    },
    yanzhengBlur(type, val, fuzhiFlag) {
      if (type == "name") {
        let reg = /^[a-zA-Z\/ ]{3,20}$/;
					let regs = /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/;
					let regName = /^([\u4e00-\u9fa5]+){2,20}$/
					let nameLanguage = ""
					if(this.InsuredModel["name"] == ""){
						this.$toast("被保人姓名不能为空")
						return true;
					}
					if(this.InsuredModel["name"].indexOf("公司") != -1){
						this.$toast("姓名不能包含“公司”")
						return true;
					}
					
					if(regName.test(this.InsuredModel["name"])){
						nameLanguage = "中文"
					}else{
						nameLanguage = "英文"
					}
					
					if(!regs.test(this.InsuredModel["name"])){
						this.$toast("姓名格式不正确")
						return true;
					}else{
						if(nameLanguage == "中文"){
							if(!regName.test(this.InsuredModel["name"])){
								this.$toast("姓名格式不正确")
								return true
							}else{
								this.InsuredModel["pinyin"] = loadPinYinInit.ConvertPinyin(this.InsuredModel["name"]);
								if(this.detail.insuranceCompanyId == 26){
									this.idTypeOption = ['身份证','护照', '港澳居民来往内地通行证','台湾居民来往内地通行证']
								}else{
									this.idTypeOption = ['身份证', '护照', '其他']
								}
								return false;
							}
						}else{
							if(!reg.test(this.InsuredModel["name"])){
								this.$toast("姓名填写不完整")
								return true
							}else if(reg.test(this.InsuredModel["name"])){
								this.InsuredModel["name"] = this.InsuredModel["name"].toUpperCase()
								if(this.detail.insuranceCompanyId == 26){
									this.idTypeOption = ['护照', '港澳居民来往内地通行证','台湾居民来往内地通行证']
								}else{
									this.idTypeOption = ['护照', '其他']
								}
								this.InsuredModel["idType"] = "护照";
							}else{
								this.InsuredModel["pinyin"] = loadPinYinInit.ConvertPinyin(this.InsuredModel["name"]);
								if(this.detail.insuranceCompanyId == 26){
									this.idTypeOption = ['身份证','护照', '港澳居民来往内地通行证','台湾居民来往内地通行证']
								}else{
									this.idTypeOption = ['身份证', '护照', '其他']
								}
								return false
							}
						}
					}
        }
    },
    onConfirmIdInsured(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.InsuredModel.idType = value;
      this.InsuredIdTypeFlag = false;
    },
    onConfirmSexInsured(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      console.log("value-----",value)
      this.InsuredModel.sex = value;
      this.InsuredSexFlag = false;
    },
    onConfirmRelatInsured(value){
      console.log("value",value)
      this.InsuredModel.relationship = value;
      this.InsuredRelatFlag = false;
    },
    onConfirmBirth(date) {
      this.policyHolder.birthDay = moment(date).format("YYYY-MM-DD");
      this.policyHolder.birthDayTime = moment(this.policyHolder.birthDay).valueOf();
      if (!this.policyHolder.birthDay) {
        this.insureError.birthday = true;
        this.$toast("投保人出生日期不能为空");
        return;
      }
      let birthday = this.moment(this.policyHolder.birthDay).format("YYYY-MM-DD");
      let endDate = this.moment(this.step1Data.startTime).format("YYYY-MM-DD");
      let age = this.jsGetAge(birthday, endDate);
      if (age < 18) {
        this.insureError.birthday = true;
        this.$toast("投保人年龄不能为小于18岁");
      } else {
        this.insureError.birthday = false;
      }
      this.birthdayFlag = false;
    },
    onConfirmBirthInsured(date) {
      this.InsuredModel.birthDay = moment(date).format("YYYY-MM-DD");
      this.InsuredModel.birthDayTime = moment(this.InsuredModel.birthDay).valueOf();
      this.InsuredModel.currentDate = date;
      this.InsuredBirthdayFlag = false;
    },
    onCancelBirth() {
      this.birthdayFlag = false;
    },
    onConfirmCal() {},

    onConfirmPlans(value) {
      this.step1Data.planName = value;
      this.detail.plans.forEach((item,index)=>{
        if(item.name == this.step1Data.planName){
          this.summarys = item.summarys
          this.step1Data.planIndex = index;
          console.log("index",index)
        }
      })
      // console.log("this.detail.plans[index].cycle",this.detail.plans[index].cycle)
      console.log("this.step1Data.planIndex",this.step1Data.planIndex)
      this.calculateOrder()
      this.chosePlanFlag = false;
    },
    onConfirmId(value, index) {
      this.policyHolder.idType = value;
      this.idTypeFlag = false;
    },
    onConfirmSex(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.policyHolder.sex = value;
      this.sexFlag = false;
    },
    onConfirmStart(value) {
      console.log("value",value)
      let days = "";
      if (this.step1Data.planDay.includes("-")) {
        let resolveEndDay = this.step1Data.planDay.match(/-(\S*)天/)[1];
        days = resolveEndDay;
      }else if(this.step1Data.planDay == "1年"){
        days = 365
      } else {
        let dayIndex = this.step1Data.planDay.lastIndexOf("天");
        let resolveStartDay = this.step1Data.planDay.substring(0, dayIndex);
        days = resolveStartDay;
      }
      console.log("days",days)
      let startDate = new Date(value).getTime();
      if (!this.detail.canTodayBuy) {
          let nextDay = new Date(startDate).setHours(0,0,0,0)
          this.step1Data.startTime = moment(nextDay).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
          if(this.detail.insuranceCompanyId == 8 || this.detail.insuranceCompanyId == 13 || this.detail.insuranceCompanyId == 27){
            let end = nextDay + days * 86400000 - 1000;
            this.step1Data.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
          }else{
            if(days == 365 || days == 366){
              let startTime = new Date(this.step1Data.startTime).getTime()
              let endDate = startTime + (86400000 * days - 1000);
              let dataTim = new Date(endDate)
              let dataStartTim = new Date(startTime)
              let year = dataTim.getFullYear()
              let month = dataStartTim.getMonth() + 1 < 10 ? "0" + (dataStartTim.getMonth() + 1) : dataStartTim.getMonth() + 1
              let dayDate = dataStartTim.getDate() < 10 ? "0" + dataStartTim.getDate() : dataStartTim.getDate();
              let dateTimer = year + "/" + month + "/" + dayDate + ' ' + '23:59:59'
              let endTime = new Date(dateTimer).getTime() - 86400000
              console.log("dateTimer",dateTimer)
              console.log("endTime",endTime)
              this.step1Data.endTime = moment(endTime).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
              console.log("this.step1Data.endTime",this.step1Data.endTime)
            }else{
              let end = nextDay + days * 86400000 - 1000;
              this.step1Data.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
            }
          }
          
			} else {
          
          this.step1Data.startTime = moment(value).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
          let nextDays = new Date(this.step1Data.startTime).getTime();
          let extraTime = this.detail.todayBuyMin ? this.detail.todayBuyMin * 60 * 1000 : 0;
          if(nextDays < new Date().getTime()+extraTime){
            this.step1Data.startTime = moment(new Date(new Date().getTime()+extraTime)).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
            nextDays = new Date(this.step1Data.startTime).getTime();
          }
          if(this.detail.insuranceCompanyId == 8 || this.detail.insuranceCompanyId == 13 || this.detail.insuranceCompanyId == 27 ){
            let end = nextDays + days * 86400000 - 1000;
            this.step1Data.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
          }else{
            if(days == 365 || days == 366){
              let startTime = moment(this.step1Data.startTime).valueOf();
              let endDate = startTime + (86400000 * days - 1000);
              let dataTim = new Date(endDate)
              let dataStartTim = new Date(startTime)
              let year = dataTim.getFullYear()
              let month = dataStartTim.getMonth() + 1 < 10 ? "0" + (dataStartTim.getMonth() + 1) : dataStartTim.getMonth() + 1
              let dayDate = dataStartTim.getDate() < 10 ? "0" + dataStartTim.getDate() : dataStartTim.getDate();
              if(moment(startTime).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')){
                let dateTimer = year + "/" + month + "/" + dayDate + ' ' + dataStartTim.getHours() + ':' + dataStartTim.getMinutes()+':' + dataStartTim.getSeconds()
                let endTime = new Date(dateTimer).getTime() - 1000
                this.step1Data.endTime = moment(endTime).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
              }else{
                let dateTimer = year + "/" + month + "/" + dayDate + ' ' + '23:59:59'
                let endTime = new Date(dateTimer).getTime() - 86400000
                this.step1Data.endTime = moment(endTime).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")  
              }
              console.log("this.step1Data.endTime",this.step1Data.endTime)
            }else{
              let end = nextDays + days * 86400000 - 1000;
              this.step1Data.endTime = moment(end).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
            }
          }
			}
      // 添加、修改被保人出生日期限制
      let year = moment(value.getTime()).format("YYYY");
      let month = moment(value.getTime()).format("MM");
      let day = moment(value.getTime()).format("DD");
      let endAge = new Date(year - this.endAge - 1, month - 1, day);
      let endage1 = this.moment(endAge.getTime() + 86400000).format("YYYY-MM-DD");
      this.InsuredModelMaxDate = new Date(year - this.startAge,month - 1,day);
      this.InsuredModelMinDate = new Date(endage1);
      this.step1DataError.startTime = false
      this.choseStartFlag = false;
      this.calculateOrder();
    },
    onCancelStart(){
      this.choseStartFlag = false
      this.blurTimer()
    },
    onConfirmEnd(value) {
      this.step1Data.endTime = moment(value.getTime() + 86400000 - 1000).format("YYYY-MM-DD HH:mm:ss");
      this.choseEndFlag = false;
      if (this.step1Data.startTime) {
        this.calculateOrder();
      }
    },
    onConfirmDay(value, index) {
      this.step1Data.planDay = value;
      if(this.step1Data.startTime){
        let daysIndex = ""
        if (this.step1Data.planDay.includes("-")) {
            let resolveEndDay = this.step1Data.planDay.match(/-(\S*)天/)[1];
            daysIndex = resolveEndDay;
        }else if(this.step1Data.planDay == "1年"){
            let dayIndex = this.step1Data.planDay.lastIndexOf("年");
            let resolveStartDay = this.step1Data.planDay.substring(0, dayIndex);
            daysIndex = 365;
        } else {
            let dayIndex = this.step1Data.planDay.lastIndexOf("天");
            let resolveStartDay = this.step1Data.planDay.substring(0, dayIndex);
            daysIndex = resolveStartDay;
        }
        let staree = new Date(this.step1Data.startTime).getTime()
        let endTim = staree + (86400000 * daysIndex - 1000);
        this.step1Data.endTime = moment(endTim).format("YYYY-MM-DD HH:mm:ss").replace(/-/g,"/")
        this.calculateOrder()
      }
      this.chosePlanTimeFlag = false;
    },
    onConfirmAge(value, index) {
      this.step1Data.planAge = value;
      console.log("value",value)
      let startt = new Date(this.step1Data.startTime).getTime()
      let year = moment(startt).format("YYYY");
      let month = moment(startt).format("MM");
      let day = moment(startt).format("DD");
      let startAgeIndex = this.step1Data.planAge.indexOf("-");
      var resolveStartAge = this.step1Data.planAge.substring(0, startAgeIndex);
      let resolveEndAge = this.step1Data.planAge.slice(-4, -2);
      let endAge = new Date(year - resolveEndAge - 1, month - 1, day);
      let endage1 = this.moment(endAge.getTime() + 86400000).format("YYYY-MM-DD");
      this.InsuredModelMaxDate = new Date(year - resolveStartAge,month - 1,day);
      this.InsuredModelMinDate = new Date(endage1);
      this.startAge = this.step1Data.planAge.substring(0, startAgeIndex);
      this.endAge = this.step1Data.planAge.slice(-4, -2);
      this.chosePlanAgeFlag = false;
    },
    checkIdcode(val) {
      return false;
    },
    checkAwayFn(val) {
      if (!this.step1Data.startTime) {
        this.$toast("请选择起保日期！");
        this.step1DataError.startTime = true
        this.checkAway = false
        return
			}else{
          this.checkAway = val
      }
      console.log("val", val);
    },
    // 删除被保险人
    delInsurePeo(item, index) {
      console.log("item", item);
      Dialog.confirm({
        title: "提示",
        message: `删除${item.name} ?`,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.InsuredList.splice(index, 1);
          this.calculateOrder();
        })
        .catch(() => {});
    },
    addOneInsured() {
      if (!this.step1Data.startTime) {
        this.$toast("请选择起保日期！");
        this.step1DataError.startTime = true
        return
			}
      let PassportNumberReg = /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
      if (this.openInsureType == "add") {
        let InsuredModel = JSON.parse(JSON.stringify(this.InsuredModel));
        console.log("InsuredModelsss", InsuredModel);
        console.log("InsuredModel", InsuredModel.idCode);
        if (
          InsuredModel.name == "" ||
          InsuredModel.idType == "" ||
          InsuredModel.idCode == "" ||
          InsuredModel.sex == "" ||
          (this.detail.hasPinyin && !InsuredModel.pinyin)
        ) {
          this.$toast.fail("请将被保人信息填写完整");
          return;
        }
        const nameFlag = this.yanzhengBlur('name',InsuredModel.name)
					console.log("nameFlag",nameFlag)
					if(nameFlag == true){
            this.$toast.fail("被保人姓名格式错误");
						return;
					}
        if (InsuredModel.idType != "社会信用代码") {
          if (InsuredModel.birthDayTime == "") {
            this.$toast.fail("请将被保人信息填写完整");
            return;
          }
        } else {
          InsuredModel.birthDayTime == "";
        }
        if (InsuredModel.idType == "其他") {
          let idCode = InsuredModel.idCode;
          let has = this.isOther(idCode);
          if (has) {
            this.$toast.fail("证件格式错误");
            return;
          }
        }
        if(this.detail.insuranceCompanyId == 17){
          if (!InsuredModel.relationship) {
            this.$toast.fail("请选择关系");
            return;
          }
        }
        // 被保人手机号验证
        let reg = /^1[3456789]\d{9}$/;
        if (InsuredModel.phone && reg.test(InsuredModel.phone * 1) == false) {
          Toast.fail("被保人手机号不正确");
          return;
        }
        if(this.detail.insuranceCompanyId == 17){
          if(InsuredModel.relationship == "本人" && this.checkAway == false){
            if((InsuredModel.name != this.policyHolder.name) || 
            (InsuredModel.idType != this.policyHolder.idType) || 
            (InsuredModel.idCode != this.policyHolder.idCode) || 
            (InsuredModel.sex != this.policyHolder.sex) || 
            (InsuredModel.birthDay != this.policyHolder.birthDay)
            ){
              Toast.fail("关系选择本人，被保险人信息要与投保人保持一致");
              return;
            }
          }
          if(InsuredModel.relationship != "本人"){
            if((InsuredModel.idCode == this.policyHolder.idCode) && (InsuredModel.idType == this.policyHolder.idType)){
              Toast.fail("当投保人与被保人证件号一致，关系只能选择“本人” ");
              return;
            }
          }
        }
        let obj = {}
        if(this.detail.insuranceCompanyId != 17){
          obj = {
            name: InsuredModel.name,
            pinyin: InsuredModel.pinyin || "",
            idType: InsuredModel.idType,
            idCode: InsuredModel.idCode,
            sex: InsuredModel.sex == "男" ? 1 : 2,
            birthday: this.moment(InsuredModel.birthDayTime).valueOf(),
            phone: InsuredModel.phone,
            num: 1,
            currentDate: InsuredModel.currentDate,
          };
        }else{
          obj = {
            name: InsuredModel.name,
            pinyin: InsuredModel.pinyin || "",
            idType: InsuredModel.idType,
            idCode: InsuredModel.idCode,
            sex: InsuredModel.sex == "男" ? 1 : 2,
            birthday: this.moment(InsuredModel.birthDayTime).valueOf(),
            relationship:InsuredModel.relationship,
            phone: InsuredModel.phone,
            num: 1,
            currentDate: InsuredModel.currentDate,
          };
        }
        console.log("objj", obj);
        this.InsuredList.push(obj);
        this.calculateOrder();
        this.changeCheck = 0;
        console.log("this.InsuredList", this.InsuredList);
      } else {
        let InsuredModel = JSON.parse(JSON.stringify(this.InsuredModel));
        console.log("InsuredModel", InsuredModel);
        if (
          InsuredModel.name == "" ||
          InsuredModel.idType == "" ||
          InsuredModel.idCode == "" ||
          InsuredModel.sex == "" ||
          (this.detail.hasPinyin && !InsuredModel.pinyin)
        ) {
          this.$toast.fail("请将被保人信息填写完整");
          return;
        }
        const nameFlag = this.yanzhengBlur('name',InsuredModel.name)
					console.log("nameFlag",nameFlag)
					if(nameFlag == true){
            this.$toast.fail("被保人姓名格式错误");
						return;
					}
        if (InsuredModel.idType != "社会信用代码") {
          if (InsuredModel.birthDayTime == "") {
            this.$toast.fail("请将被保人信息填写完整");
            return;
          }
        } else {
          InsuredModel.birthDayTime == "";
        }
        if (InsuredModel.idType == "护照") {
          if (!PassportNumberReg.test(InsuredModel.idCode)) {
            this.$toast.fail("护照号码格式错误");
            return;
          }
        }
        if (InsuredModel.idType == "其他") {
          let idCode = InsuredModel.idCode;
          let has = this.isOther(idCode);
          if (has) {
            this.$toast.fail("证件格式错误");
            return;
          }
        }
        if(this.detail.insuranceCompanyId == 17){
          if (!InsuredModel.relationship) {
            this.$toast.fail("请选择关系");
            return;
          }
        }
        // 被保人手机号验证
        let reg = /^1[3456789]\d{9}$/;
        if (InsuredModel.phone && reg.test(InsuredModel.phone * 1) == false) {
          Toast.fail("被保人手机号不正确");
          return;
        }
        if(this.detail.insuranceCompanyId == 17){
          if(InsuredModel.relationship == "本人" && this.checkAway == false){
            if((InsuredModel.name != this.policyHolder.name) || 
            (InsuredModel.idType != this.policyHolder.idType) || 
            (InsuredModel.idCode != this.policyHolder.idCode) || 
            (InsuredModel.sex != this.policyHolder.sex) || 
            (InsuredModel.birthDay != this.policyHolder.birthDay)
            ){
              Toast.fail("关系选择本人，被保险人信息要与投保人保持一致");
              return;
            }
          }
          if(InsuredModel.relationship != "本人"){
            if((InsuredModel.idCode == this.policyHolder.idCode) && (InsuredModel.idType == this.policyHolder.idType)){
              Toast.fail("只有关系选择“本人”时，被保人证件号才能和投保人一致");
              return;
            }
          }
        }
        if(this.detail.insuranceCompanyId != 17){
          this.InsuredList[this.openInsureIndex] = {
            name: InsuredModel.name,
            pinyin: InsuredModel.pinyin || "",
            idType: InsuredModel.idType,
            idCode: InsuredModel.idCode,
            sex: InsuredModel.sex == "男" ? 1 : 2,
            birthday: this.moment(InsuredModel.birthDayTime).valueOf() || "",
            phone: InsuredModel.phone,
            num: 1,
            currentDate: InsuredModel.currentDate,
          };
        }else{
          this.InsuredList[this.openInsureIndex] = {
            name: InsuredModel.name,
            pinyin: InsuredModel.pinyin || "",
            idType: InsuredModel.idType,
            idCode: InsuredModel.idCode,
            sex: InsuredModel.sex == "男" ? 1 : 2,
            birthday: this.moment(InsuredModel.birthDayTime).valueOf() || "",
            relationship:InsuredModel.relationship,
            phone: InsuredModel.phone,
            num: 1,
            currentDate: InsuredModel.currentDate,
          };
        }
        console.log(
          "this.InsuredList[this.openInsureIndex]",
          this.InsuredList[this.openInsureIndex]
        );
      }
      this.changeCheck = 0;
    },
    async payOrder() {
      if (this.openBalance == "1" && this.whetherPayCode == "1" && this.payType == 3) {
        this.payMoneyFlag = true;
        if (this.paymentCodePwd) {
          let downFlag = await this.buildBill(this.orderIds);
          if (!downFlag) {
            return;
          }
        }
      } else {
        let downFlag = await this.buildBill(this.orderIds);
        if (!downFlag) {
          return;
        }
        var self = this;
        if(this.payType == 1){
          if(!this.$page.isInWechat && !this.$page.isInAlipay){
            Dialog.confirm({
              title: "",
              message: '受支付方式限制，请将链接复制到微信页面中打开',
              confirmButtonText: "知道了",
              showCancelButton:false,
            }).then(() => {
                
            }).catch(() => {});
            return;
          }

          this.$toast({
            type: "loading",
            message: "订单支付中...",
            forbidClick: true,
            overlay: true,
            duration: 0,
            loadingType: "spinner"
          });
          let wechatParams = {
            accountBillId: this.billId,
            paytype: this.$page.isInAlipay ? "A01" : "W01",
            // acct: this.publicData.parentId == 0 ? this.publicData.parentId :this.publicData.id,
            acct:this.$route.query.accountId,
          };
          let wechatRes = await this.$http.post("/api/order.union.create",wechatParams);
          console.log("wechatRes", wechatRes);
          if (wechatRes.code == 0) {
            this.$toast.clear()
            //成功
            location.href = wechatRes.t.payinfo;
          } else {
            this.$toast.clear()
            if(wechatRes && wechatRes.msg){
              this.$toast.fail(wechatRes.msg);
            }
          }
        }
      }
    },
    async prePayOrder() {
      if (!this.step1Data.startTime) {
        this.$toast("请选择起保日期！");
        this.step1DataError.startTime = true
        return
			}
      if (!this.subchecked) {
        this.$toast("请先阅读页面下方投保条款后勾选！");
        return;
      }
      if(new Date(this.step1Data.startTime).getTime() <= new Date().getTime()){
        //小于当前时间投保日期自动后延并提示
        this.$toast("起保时间必须大于当前时间，已为您自动延长起保时间，望知悉！");
        this.onConfirmStart(new Date(this.step1Data.startTime)); 
        return;
      }
      if (this.detail.exemption ||this.detail.agreement ||this.detail.insureNotice) {
        //逐条阅读
        for (let i = 0; i < this.isReady1Arr.length; i++) {
          if (!this.isReady1Arr[i]) {
            this.isReady1Flag = true;
            this.isReady1Arr[0] = 1;
            this.$toast(
              "请逐步阅读完并同意《免责内容》《被保险人同意声明》《投保提示》！"
            );
            return false;
          }
        }
      }
      // if (!this.riskchecked && this.loadList.riskNotification == "1") {
      //   this.$toast("请先阅读页面下方风险活动后勾选！");
      //   return;
      // }
      await this.changeStep(1);
    },
    shareTags() {
      console.log("this.shareIndex", this.shareIndex);
      if (this.shareIndex == 1) {
        this.$router.push({
          name: "CpsOrder",
          query: {
            accountId:this.$route.query.accountId,
            companyId:this.$route.query.companyId,
            id:this.$route.query.id,
            fixedOrNot: this.loadList.fixedOrNot, //1使用固定投保人 0不使用固定投保人
            showBalance: this.showBalance,
          },
        });
      }
    },
    getAge(UUserCard) {
      //获取年龄
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      var day = myDate.getDate();
      var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
      if (
        UUserCard.substring(10, 12) < month ||
        (UUserCard.substring(10, 12) == month &&
          UUserCard.substring(12, 14) <= day)
      ) {
        age++;
      }

      return age;
    },
    getBirthdayFromIdCard(idCard) {
      //根据身份证计算生日格式1997-00-00
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }
      return birthday;
    },
    jsGetAge(strBirthday, edtTime) {
      console.log("strBirthday", strBirthday);
      var birthYear = strBirthday.slice(0, 4);
      var birthMonth = strBirthday.slice(5, 7);
      var birthDay = strBirthday.slice(8);
      var d = edtTime;
      console.log("d", d);
      var nowYear = d.slice(0, 4);
      var nowMonth = d.slice(5, 7);
      var nowDay = d.slice(8);
      let age = nowYear - birthYear -  (nowMonth < birthMonth || (nowMonth == birthMonth && nowDay < birthDay) ? 1 : 0);
      console.log("agegege", age);
      return age; //返回周岁年龄
    },
    isOther(idCode) {
      let newReg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      let regs = /^[a-zA-Z]+$/;
      let other = new RegExp("[A-Za-z0-9]", "g"); //只需包含数字和英文
      let hasErr = true;
      if (idCode.length >= 5 && idCode.length <= 20) {
        if (!newReg.test(idCode)) {
          console.log(other.test(idCode));
          console.log(!regs.test(idCode));
          if (other.test(idCode) && !regs.test(idCode)) {
            hasErr = false;
          }
        }
      }
      if (hasErr) {
        return true;
      } else {
        return false;
      }
    },
  },
  filters: {
    checkIdName(val) {
      if (val.length < 2) {
        return `<span style="color:red;font-size:12px;padding-left:8px">姓名填写不完整</span>`;
      }
      let regs = /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/;
      if (!regs.test(val)) {
        return `<span style="color:red;font-size:12px;padding-left:8px">姓名格式不正确</span>`;
      } else {
        return val;
      }
    },
    checkIdCode(val, type, that) {
      if (val) {
        let codes = that.InsuredList.map((v) => v.idCode);
        if (
          that.InsuredList.filter((v) => v.idCode == val).length > 1 &&
          codes.includes(val)
        ) {
          return `<span style="color:red;font-size:12px">${val}证件号重复</span>`;
        }
        var PassportNumberReg =
          /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
        if (type == "身份证") {
          if (util.isCardID(val)) {
            return val;
          } else {
            return `<span style="color:red;font-size:12px">${val}证件号有误</span>`;
          }
        }
        if (type == "护照") {
          if (PassportNumberReg.test(val)) {
            return val;
          } else {
            return `<span style="color:red;font-size:12px">${val}护照号码格式错误</span>`;
          }
        }
        if (type == "其他") {
          let newReg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
          let regs = /^[a-zA-Z]+$/;
          let other = new RegExp("[A-Za-z0-9]", "g"); //只需包含数字和英文
          let hasErr = true;
          if (val.length >= 5 && val.length <= 20) {
            if (!newReg.test(val)) {
              if (other.test(val) && !regs.test(val)) {
                hasErr = false;
              }
            }
          }
          if (hasErr) {
            return `<span style="color:red;font-size:12px">${val}证件格式错误</span>`;
          } else {
            return val;
          }
        }
      }
    },
    checkBirthday(val, that) {
      if (val) {
        //验证被保人年龄是否在保障期限内
        let birthday = that.moment(val).format("YYYY-MM-DD");
        // let endDate = that.moment(that.step1Data.startTime ? that.step1Data.endTime : new Date().getTime()).format("YYYY-MM-DD");
        let endDate = that
          .moment(that.step1Data.startTime)
          .format("YYYY-MM-DD");
        let age = that.jsGetAge(birthday, endDate);
        console.log("被保人age", age);
        console.log("val", val);
        // if (age > that.detail.endAge || age < that.detail.fromAge) {
        if (age > that.endAge || age < that.startAge) {
          return `<span style="color:red;font-size:12px">${
            that.moment(val).format("YYYY-MM-DD") + "被保人年龄需在承保年龄内"
          }</span>`;
        } else {
          return that.moment(val).format("YYYY-MM-DD");
        }
      } else {
        return `<span style="color:red;font-size:12px">请选择出生日期</span>`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-picker-column__item--selected {
  color: #00d385;
  font-weight: 600;
  font-size: 18px;
}

.qrcode {
  width: 100%;
  height: 100%;
  // height: 100%;
  // background: #fff;
  padding-bottom: 50px;
  overflow-x: hidden;
  box-sizing: border-box;
  font-size: 14px;
  position: relative;
  .shareTabs {
    margin-bottom: 10px;
  }
  .poster {
    width: 100%;
    display: flex;
    img {
      width: 100%;
    }
  }
  .qrcode-info {
    padding: 10px;
    box-sizing: border-box;
    .title {
      width: 100%;
      height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      border-bottom: 1px solid #eee;
      line-height: 40px;
    }
    .name-info {
      height: 170px;
      width: 100%;
      margin: 0 auto;
      margin-top: 10px;
      padding: 10px 6px;
      box-sizing: border-box;
      background: #eee;
      border-radius: 10px;

      .name-list-text {
        width: 100%;
        height: 30px;
        border-radius: 16px;
        line-height: 30px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
      }

      .name-list-info {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-left: 32px;
        box-sizing: border-box;

        .name-list-info-left {
          font-size: 28px;
          height: 60px;
          line-height: 60px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .name-list-info-right {
          height: 45px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 45px;
          display: flex;
        }
      }
    }
    .add-Btn {
      width: 150px;
      height: 30px;
      background: #21c28f;
      border-radius: 8px;
      color: #ffffff;
      line-height: 30px;
      text-align: center;
      margin-top: 10px;
    }
    .save-Btn {
      width: 240px;
      height: 35px;
      background: #21c28f;
      border-radius: 20px;
      color: #ffffff;
      line-height: 35px;
      text-align: center;
      margin: 0 auto;
      margin-top: 15px;
    }
    .Insurededit {
      margin-top: 20px;
      box-sizing: border-box;
    }
    .tipcheck {
      width: 100%;
      display: flex;
      background: rgba(255, 255, 255, 1);
      // height: 160px;
      height: 120px;
      padding: 0 10px;
      margin-top: 10px;
      box-sizing: border-box;
      font-size: 12px;
      flex-direction: column;
      justify-content: center;
      .van-checkbox {
        margin: 5px 0;
        overflow: inherit;
      }
      .text {
        font-size: 14px;
        color: #000;
        line-height: 1.4;
        b {
          color: #fb4a41;
          font-weight: 400;
        }
      }
    }
    
  }
  .step1 {
    .info {
      padding: 10px;
      box-sizing: border-box;
      .title {
        height: 40px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #eee;
        .text {
          width: 100%;
          height: 40px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 40px;
        }
      }
      .inp-box {
        .item {
          display: flex;
          font-size: 14px;
          .label {
            width: 90px;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-start;
          }
        }
        .item1 {
          padding-top: 10px;
          font-size: 14px;
          .item1-text {
            font-size: 12px;
            text-align: left;
            line-height: 20px;
            color: orange;
          }
          .label {
            width: 90px;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-start;
          }
        }
      }
      .add-box {
        text-align: center;
        font-size: 0.26rem;
        color: #2e2d2d;
        line-height: 0.4rem;
        font-weight: 700;
        padding: 0.25rem 0 0.25rem;
        // border-top: 1px solid #f1f1f1;
        .add-link {
          width: 2rem;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 15px;
            margin-right: 5px;
          }
        }
      }
      .qrcode-info {
    padding: 10px;
    box-sizing: border-box;
    .title {
      width: 100%;
      height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      border-bottom: 1px solid #eee;
      line-height: 40px;
    }
    .name-info {
      height: 170px;
      width: 100%;
      margin: 0 auto;
      margin-top: 10px;
      padding: 10px 6px;
      box-sizing: border-box;
      background: #eee;
      border-radius: 10px;

      .name-list-text {
        width: 100%;
        height: 30px;
        border-radius: 16px;
        line-height: 30px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
      }

      .name-list-info {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding-left: 32px;
        box-sizing: border-box;

        .name-list-info-left {
          font-size: 28px;
          height: 60px;
          line-height: 60px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }

        .name-list-info-right {
          height: 45px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 45px;
          display: flex;
        }
      }
    }
    .add-Btn {
      width: 150px;
      height: 30px;
      background: #21c28f;
      border-radius: 8px;
      color: #ffffff;
      line-height: 30px;
      text-align: center;
      margin-top: 10px;
    }
    .save-Btn {
      width: 240px;
      height: 35px;
      background: #21c28f;
      border-radius: 20px;
      color: #ffffff;
      line-height: 35px;
      text-align: center;
      margin: 0 auto;
      margin-top: 15px;
    }
    .Insurededit {
      margin-top: 20px;
      box-sizing: border-box;
    }
    .tipcheck {
      width: 100%;
      display: flex;
      background: rgba(255, 255, 255, 1);
      // height: 160px;
      height: 120px;
      padding: 0 10px;
      margin-top: 10px;
      box-sizing: border-box;
      font-size: 12px;
      flex-direction: column;
      justify-content: center;
      .van-checkbox {
        margin: 5px 0;
        overflow: inherit;
      }
      .text {
        font-size: 14px;
        color: #000;
        line-height: 1.4;
        b {
          color: #fb4a41;
          font-weight: 400;
        }
      }
    }
    
  }
      .people-list {
        width: 100%;
        .people-item {
          display: flex;
          border-bottom: 1px solid #f1f1f1;
          padding: 10px 0;
          box-sizing: border-box;
          .right {
            width: 100px;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;
            font-size: 0.15rem;
            align-items: center;
            position: relative;
            .del {
              position: absolute;
              right: 0;
              top: 0;
              z-index: 5;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .left {
            flex: 1;
            .name {
              font-size: 0.15rem;
              font-weight: 700;
              color: #333;
            }
            .tip {
              font-size: 0.12rem;
              color: #848484;
              line-height: 0.15rem;
              margin-top: 0.09rem;
              display: flex;
              .idtype {
                margin-right: 8px;
              }
            }
          }
        }
      }
      .info-item-box {
        padding-top: 20px;
        box-sizing: border-box;
        .partOne {
          width: 85%;
          margin: 0 auto;
          position: relative;
          .imgBaoan {
            width: 50px;
            height: 50px;
            position: absolute;
            left: -22px;
            top: 15px;
          }

          .content-BA {
            width: 81%;
            height: 135px;
            position: absolute;
            text-align: justify;
            top: 20px;
            left: 30px;

            .ptitle {
              height: 35px;
              line-height: 32px;
              font-size: 17px;
              color: #000;
              font-weight: normal;
            }

            .ptext {
              font-size: 15px;
              color: rgb(127, 127, 127);
              line-height: 23px;
            }
          }
        }

        .partTwo {
          width: 85%;
          height: 130px;
          margin: 0 auto;
          position: relative;

          .imgBaoan {
            width: 50px;
            height: 50px;
            position: absolute;
            right: -18px;
            top: -33px;
          }

          .lineRight {
            width: 125px;
            height: 120px;
            position: absolute;
            right: 0px;
          }

          .content-LP {
            width: 81%;
            height: 270px;
            position: absolute;
            text-align: justify;
            top: 20px;
            left: 30px;

            .ptitle {
              line-height: 32px;
              font-size: 17px;
              color: #000;
              font-weight: normal;
              position: absolute;
              right: 7px;
              top: -18%;
            }

            .ptext {
              font-size: 15px;
              color: rgb(127, 127, 127);
              line-height: 22px;
            }
          }
        }

        .partThree {
          width: 85%;
          margin: 0 auto;
          position: relative;

          .imgBaoan {
            width: 50px;
            height: 50px;
            position: absolute;
            left: -22px;
            top: -45px;
          }

          .content-BA {
            width: 81%;
            height: 250rpx;
            position: absolute;
            text-align: justify;
            top: 20px;
            left: 30px;

            .ptitle {
              line-height: 32px;
              font-size: 17px;
              color: #000;
              font-weight: normal;
              position: absolute;
              top: -55px;
              left: 1px;
            }

            .ptext {
              font-size: 15px;
              color: rgb(127, 127, 127);
              line-height: 22px;
            }
          }
        }

        .partFour {
          width: 85%;
          height: 145px;
          margin: 0 auto;
          position: relative;

          .imgBaoan {
            width: 50px;
            height: 50px;
            position: absolute;
            right: -18px;
            top: -35px;
          }

          .lineRight {
            width: 115px;
            height: 130px;
            position: absolute;
            right: 0px;
          }

          .content-LP {
            width: 81%;
            height: 120px;
            position: absolute;
            text-align: justify;
            top: 20px;
            left: 30px;

            .ptitle {
              line-height: 32px;
              font-size: 17px;
              color: #000;
              font-weight: normal;
              position: absolute;
              right: 14px;
              top: -38%;
            }

            .ptext {
              font-size: 15px;
              color: rgb(127, 127, 127);
              line-height: 22px;
            }
          }
        }
        .info-title {
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #f7f7f7;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }

        .info-title2 {
          color: orange;
          padding: 15px 0;
        }

        .info-title3 {
          color: #666666;
          line-height: 25px;
        }

        .info-content {
          padding: 15px 0px;
          margin-top: 15px;
        }
      }
      .item-sumary{
          display: flex;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          .label {
            width: 0.8rem;
            flex-shrink: 0;
          }
        .text {
            flex: 1;
            color: #333333;
            .summary-info {
              width: 100%;
              padding-top: 5px;
              box-sizing: border-box;
              // ul{
              li {
                display: flex;
                padding:10px 0px;
                border-bottom: 1px solid #eee;
                font-size: 14px;
                .price {
                  // width: 80px;
                  flex-shrink: 0;
                  width: 30%;
                  text-align: right;
                }
                .name {
                  flex: 1;
                  width: 70%;
                  text-align: left;
                }
              }
              // }
            }
          }
      }
    }
  }

  .detail-info {
    padding: 15px;
    box-sizing: border-box;
    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    .title_little {
      display: flex;
      align-items: center;
      height: 30px;
      .sale_count {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-left: 5px;
      }
    }
    .big-info {
      .item {
        display: flex;
        margin-bottom: 0.03rem;
        .label {
          width: 65px;
          height: 20px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          flex-shrink: 0;
          line-height: 20px;
        }
        .item-info {
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          .item-btn {
            // width:55px;
            height: 28px;
            border-radius: 4px;
            border: 1px solid rgba(172, 172, 172, 1);
            padding: 0 10px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            margin: 0 3px;
            margin-right: 10px;
            flex-shrink: 0;
            margin-bottom: 5px;
            min-width: 75px;
            box-sizing: border-box;
            &.option-cur {
              background: rgba(0, 211, 133, 0.05);
              border-radius: 4px;
              border: 1px solid rgba(0, 211, 133, 1);
              color: rgba(0, 211, 133, 1);
            }
          }

          .company {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
          }

          .fuhao {
            font-size: 12px;
            color: #ff1010;
          }
          .price {
            color: #ff1010;
            font-size: 20px;
          }
        }
        .summary-info {
          width: 100%;
          padding-top: 5px;
          box-sizing: border-box;
          .item {
            display: flex;
            font-size: 13px;
            width: 100%;
            .title {
              width: 70%;
              color: #888;
              font-size: 13px;
            }
            .price {
              width: 30%;
              color: #000;
              text-align: right;
              font-size: 13px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  .select-plan1 {
    width: 100%;
    position: relative;
    .jiantou {
      position: absolute;
      right: 0;
      top: 29px;
      width: 30px;
      // transform: translateY(-50%);
    }
    .title-box {
      height: 40px;
      // padding: 0 15px;
      .price {
        height: 25px;
        line-height: 25px;
        font-size: 16px;
        font-weight: 700;
        color: #666;
        display: flex;
        justify-content: center;
        .fuhao {
        }
      }
      .title {
        display: flex;
        justify-content: center;
      }
    }
  }
  #content2 {
    // padding: 15px;
    box-sizing: border-box;
    padding: 0 15px;
    box-sizing: border-box;
    line-height: 1.8;
    * {
      box-sizing: border-box;
    }
  }
  #content3 {
    padding: 0 15px;
    box-sizing: border-box;
    line-height: 1.8;
  }
  #content4 {
    .img-box {
      padding: 15px;
      box-sizing: border-box;
      padding-bottom: 0px;
      img {
        width: 100%;
      }
    }
    .direct-box {
      padding: 15px;
      box-sizing: border-box;
      p {
        font-size: 13px;
        color: #666;
        line-height: 20px;
        margin: 10px 0;
      }
    }
  }
  .foot-btn1 {
    height: 50px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -1px 8px 3px rgba(0, 0, 0, 0.04);
    // position: absolute;
    // bottom: 0;
    width: 100%;
    display: flex;
    // z-index: 2000;
    .price {
      color: #ff4e33;
      font-weight: 700;
      font-size: 18px;
      width: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .right {
      flex: 1;
      background: rgba(0, 211, 133, 1);
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: rgba(255, 255, 255, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      // font-weight: 500;
    }
  }
  .calcurePrice {
    width: 100%;
    padding-bottom: 50px;
    .title {
      border-bottom: 1px solid #f1f1f1;
      font-size: 16px;
      font-weight: 500;
      color: #000;
      position: relative;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .close {
      position: absolute;
      font-size: 14px;
      color: #fb4a41;
      right: 30px;
      top: 20px;
    }
    .plan_start {
      height: 45px;
    }
    .item {
      display: flex;
      margin-bottom: 0.1rem;
      padding-left: 16px;
      box-sizing: border-box;
      .label {
        width: 75px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        flex-shrink: 0;
        line-height: 20px;
      }
      .item-info {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        .item-btn {
          // width:55px;
          height: 28px;
          border-radius: 4px;
          border: 1px solid rgba(172, 172, 172, 1);
          padding: 0 10px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          margin: 0 3px;
          margin-right: 10px;
          flex-shrink: 0;
          margin-bottom: 5px;
          min-width: 75px;
          box-sizing: border-box;
          &.option-cur {
            background: rgba(0, 211, 133, 0.05);
            border-radius: 4px;
            border: 1px solid rgba(0, 211, 133, 1);
            color: rgba(0, 211, 133, 1);
          }
        }

        .company {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 20px;
        }

        .fuhao {
          font-size: 12px;
          color: #ff1010;
        }
        .price {
          color: #ff1010;
          font-size: 20px;
        }
      }
      .summary-info {
        width: 100%;
        padding-top: 5px;
        box-sizing: border-box;
        .item {
          display: flex;
          font-size: 13px;
          width: 100%;
          .title {
            width: 70%;
            color: #888;
            font-size: 13px;
          }
          .price {
            width: 30%;
            color: #000;
            text-align: right;
            font-size: 13px;
            font-weight: 500;
          }
        }
      }
    }
  }
  .isReady_content {
    max-height: 430px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    padding: 15px 10px;
    box-sizing: border-box;
    width: 100%;
    .content {
      width: 100%;
      font-size: 12px;
    }
  }
   .foot-btn {
    height: 50px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -1px 8px 3px rgba(0, 0, 0, 0.04);
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    z-index: 2;
    // left: 0;
    .left {
      width: 55%;
      flex-shrink: 0;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 211, 133, 1);
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      position: relative;
      &:after {
        content: " ";
        position: absolute;
        top: 0;
        width: 1px;
        bottom: 0;
        color: #c7c7c7;
        right: 0;
        // border-right: 1px solid #c7c7c7;
        transform: scaleX(0.5);
        height: 60%;
        top: 50%;
        transform: translateY(-50%);
      }
      a {
        img {
          width: 25px;
          height: 25px;
        }
      }
    }
    .price {
      color: #ff4e33;
      font-weight: 700;
      font-size: 18px;
      // width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .right {
      flex: 1;
      background: rgba(0, 211, 133, 1);
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: rgba(255, 255, 255, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      // font-weight: 500;
    }
  }

}
.noticePdf {
  .title {
    font-size: 16px;
    font-weight: 700;
    color: #000;
    text-align: center;
    margin-top: 20px;
  }
  p {
    line-height: 25px;
    font-size: 13px;
    span {
      color: #00a971;
      cursor: pointer;
      font-weight: 500;
    }
    &.in {
      text-indent: 20px;
    }
    &.huang {
      color: #f8ad00;
    }
  }
}
</style>

<style lang="scss">
#plans-tab {
  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border-width: 0 !important;
  }
}
#detail-tabs {
  .van-tabs__line {
    background: #00d385;
  }
}
.select-plan1 {
  .van-tabs__nav {
    background: #f4f4f4;
    padding-left: 5px;
    box-sizing: border-box;
    padding-right: 5px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .van-tabs--line .van-tabs__wrap {
    height: 70px;
  }
  .van-tabs__nav .van-tab {
    flex-shrink: 0;
    min-width: 30%;
    height: 70px;
    background: #fff;
    padding: 0;
    // margin: 0 10px;
    margin-left: 5px;
    border-radius: 8px 8px 0 0;
  }
  .van-tabs__nav .van-tab--active {
    background-image: linear-gradient(#00e59e, #00d39d);
    // background: rgba(0,0,0,0  );
    .price {
      color: #fff !important;
    }
    .title {
      color: #fff !important;
    }
  }

  .van-tab--active:before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    left: 50%;
    transform: translateY(-50%);
    bottom: -15px;
    border-top: solid 15px black;
    border-right: solid 15px transparent;
    border-left: solid 15px transparent;
    display: none;
  }
  .van-tabs__line {
    width: 0;
    height: 0;
    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
    border-top: 100px solid red;
    display: none;
  }
  .summary-info {
    padding: 15px;
    .item {
      display: flex;
      font-size: 13px;
      width: 100%;
      margin-bottom: 0.15rem;
      .title {
        width: 70%;
        color: #888;
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .price {
        width: 30%;
        color: #000;
        text-align: right;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
}
.shareTabs {
  .van-tabs__line {
    background-color: #21c28f;
  }
}
.Insurededit {
  .item .van-field__body {
    border-bottom: 1px solid #f1f1f1;
  }
  .van-cell {
    padding-left: 0;
    padding-right: 0;
    padding: 5px 16px;
  }
}
.step1 {
  .info {
    .van-cell {
      padding-left: 0;
      padding-right: 0;
      padding: 5px 0px;
    }
    .insurepeopel_box {
      .van-cell {
        padding-left: 6px;
      }
      .van-cell--required::before {
        left: 0px;
        top: 50%;
        transform: translateY(-50%);
      }
      .error {
        border: 1px solid red;
        box-sizing: border-box;
      }
    }
    .title {
      height: 35px;
      line-height: 35px;
    }
    .inp-box {
      .item {
        .van-field__label {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
        }
        .van-field__body {
          border-bottom: 1px solid #f1f1f1;
          .timeSelect {
            width: 100%;
            height: 30px;
            // background-color: blanchedalmond;
            overflow: hidden;
            .timeSelect_Start {
              width: 48%;
              height: 30px;
              line-height: 30px;
              float: left;
              text-align: left;
            }
            span {
              padding: 0 1px;
            }
            .timeSelect_End {
              width: 48%;
              height: 30px;
              line-height: 30px;
              float: right;
              text-align: right;
            }
          }
        }
      }
    }
  }
}
.payStyle {
  .payTitle {
    font-size: 16px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .payPrice {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
  }
  .payTypeStyle {
    height: 60px;
    line-height: 60px;
    margin: 0 auto;
    width: 90%;
    display: flex;
    font-size: 16px;
    justify-content: space-between;
  }
}
.tipcheck{
  .van-checkbox__icon{
    margin-right: 8px;
  }
}
</style>
